export const pagesData = {
  "index": {
    "title": "Autoriseret Kloakmester i Galten & Skanderborg | Jan Hedegaard",
    "meta": {
      "description": "Brug for autoriseret kloakmester i Galten, Skanderborg eller omegn? Vi udfører kloakseparering, TV-inspektion & entreprenørarbejde. Få et tilbud!",
      "ogTitle": "Autoriseret Kloakmester i Galten & Skanderborg | Jan Hedegaard",
      "ogDescription": "Brug for autoriseret kloakmester i Galten, Skanderborg eller omegn? Vi udfører kloakseparering, TV-inspektion & entreprenørarbejde. Få et tilbud!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/43586154-92d6-43c8-8757-0c72ffc22dd7.jpg",
      "lang": "da-DK"
    },
    "schema_markup": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvad laver en autoriseret kloakmester?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En autoriseret kloakmester udfører blandt andet etablering, reparation og vedligeholdelse af kloaksystemer efter gældende regler. Entreprenør Jan Hedegaard har over 20 års erfaring, udfører både små og store opgaver og sørger for relevant dokumentation efter arbejdet."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår bør man kontakte et kloakfirma?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Det kan være relevant at kontakte et kloakfirma ved tilbagevendende stop, dårlig lugt, fugt eller problemer med afløbet. Entreprenør Jan Hedegaard tilbyder kloakservice med grundig undersøgelse og fejlfinding for både private og erhverv."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster kloakarbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på kloakarbejde afhænger blandt andet af opgavens omfang, jordbundsforholdene og behovet for gravearbejde. Entreprenør Jan Hedegaard begynder med en samtale og vurdering af de eksisterende forhold og giver gerne et uforpligtende tilbud på en løsning, der passer til ejendommen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan finder en kloakmester fejl og skader i kloakken?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En kloakmester kan benytte TV-inspektion og elektronisk sporing til at lokalisere skader, brønde og rørforløb. Entreprenør Jan Hedegaard anvender grundig fejlfinding som en del af sin kloakservice, så arbejdet kan planlægges ud fra de konkrete forhold."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er kloakseparering nødvendig?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Kloakseparering kan være nødvendig efter et kommunalt påbud eller som en forbedring af ejendommens kloaksystem. Entreprenør Jan Hedegaard undersøger forholdene, planlægger en praktisk rørføring og sørger for, at regnvand og spildevand føres i hver sin ledning."
          }
        },
        {
          "@type": "Question",
          "name": "Kan én entreprenør og kloakmester udføre hele opgaven?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja, Entreprenør Jan Hedegaard kan samle kloakarbejde med nødvendigt jord- og gravearbejde. Det kan blandt andet omfatte udgravning, dræn, faskiner og efterfølgende reetablering af græsplæne, terrasse eller indkørsel med fokus på stabil bundopbygning og korrekt komprimering."
          }
        },
        {
          "@type": "Question",
          "name": "Hvilken dokumentation får man efter udført kloakarbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Efter udført kloakarbejde sørger Entreprenør Jan Hedegaard som autoriseret kloakmester for den relevante dokumentation. Ved kloakseparering håndterer virksomheden også den nødvendige dokumentation til kommunen."
          }
        }
      ]
    },
    "headline": "Autoriseret kloakmester med over 20 års erfaring",
    "subhead": "Hos Entreprenør Jan Hedegaard får du en autoriseret kloakmester med base i Galten og over 20 års erfaring. Vi udfører små og store opgaver for private og erhverv og tilpasser altid arbejdet til ejendommen, dine ønsker og de praktiske forhold.",
    "ctaText": "Få et uforpligtende tilbud",
    "ctaHref": "/kontakt",
    "sections": [
      {
        "type": "intro",
        "badge": "Autoriseret kloakmester med over 20 års erfaring",
        "h1": "Autoriseret kloakmester med over 20 års erfaring",
        "lead": "Hos Entreprenør Jan Hedegaard får du en autoriseret kloakmester med base i Galten og over 20 års erfaring. Vi udfører små og store opgaver for private og erhverv og tilpasser altid arbejdet til ejendommen, dine ønsker og de praktiske forhold.",
        "h2": "Autoriseret kloakarbejde i Galten udført korrekt fra begyndelsen",
        "paragraphs": [
          "Kloakarbejde kræver faglig viden, præcision og kendskab til gældende regler. Vi hjælper blandt andet med etablering, reparation og vedligeholdelse af kloaksystemer. Som autoriseret kloakmester sørger vi også for den relevante dokumentation efter arbejdet.",
          "Hvert projekt begynder med en samtale og en vurdering af de eksisterende forhold. Prisen afhænger blandt andet af opgavens omfang, jordbund og behovet for gravearbejde. Som lokalt kloakfirma lægger vi vægt på klare aftaler og en løsning, der passer til din ejendom."
        ],
        "links": [
          { "label": "Kloakmesterarbejde", "href": "/kloakmester-arbejde" },
          { "label": "Kloakservice", "href": "/kloakservice" },
          { "label": "Kloakseparering", "href": "/kloakseparering" },
          { "label": "Entreprenørarbejde", "href": "/entreprenoerarbejde" },
          { "label": "Anlæg og belægning", "href": "/anlaeg-og-belaegning" },
          { "label": "Haveservice", "href": "/haveservice" }
        ]
      },
      {
        "type": "kloakservice",
        "h2": "Kloakservice med grundig fejlfinding",
        "paragraphs": [
          "Tilbagevendende stop, dårlig lugt, fugt eller problemer med afløbet kan være tegn på fejl i kloakken. Vores [kloakservice](/kloakservice) omfatter grundig undersøgelse og fejlfinding. Med TV inspektion og elektronisk sporing kan vi lokalisere skader, brønde og rørforløb."
        ],
        "h3": "Hvornår er kloakseparering den rigtige løsning",
        "separering_paragraphs": [
          "Ved [kloakseparering](/kloakseparering) bliver regnvand og spildevand ført i hver sin ledning. Det kan være nødvendigt efter et kommunalt påbud eller som en del af en forbedring af ejendommens kloaksystem. Vi undersøger forholdene og planlægger en praktisk rørføring.",
          "Vi udfører selve arbejdet og sørger for den nødvendige dokumentation til kommunen. Når det er muligt, planlægger vi arbejdet med mindst mulig påvirkning af have og indkørsel. Vi kan også rådgive om faskiner og andre løsninger til håndtering af regnvand."
        ],
        "list": [
          "Grundig TV-inspektion og elektronisk sporing af rørforløb",
          "Lokalisering og udbedring af skader, brud og stoppede brønde",
          "Separering af regnvand og spildevand i to separate ledninger",
          "Rådgivning og etablering af faskiner og regnvandsløsninger",
          "Autoriseret færdigmelding og dokumentation til kommunen",
          "Minimeret påvirkning af have, indkørsel og belægninger"
        ]
      },
      {
        "type": "gallery_teaser",
        "title": "Se tidligere udført kloakarbejde",
        "subtitle": "Lad os stå for dit næste projekt. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
        "ctaText": "Se flere her",
        "ctaHref": "/galleri"
      },
      {
        "type": "full_service",
        "h2": "Én entreprenør og kloakmester til hele opgaven",
        "paragraphs": [
          "Som entreprenør og kloakmester kan vi samle kloakarbejde med det nødvendige jord og gravearbejde. Vi udfører blandt andet udgravning til fundamenter, dræn og faskiner samt klargøring til indkørsler, terrasser og andre belagte arealer.",
          "Når kloakken ligger under en græsplæne, terrasse eller indkørsel, er reetableringen en vigtig del af resultatet. Vi kan derfor håndtere flere sammenhængende arbejdsfaser og genetablere de berørte arealer med fokus på stabil bundopbygning og korrekt komprimering."
        ],
        "list": [
          "Udgravning til fundamenter, dræn og faskiner",
          "Klargøring til indkørsler, terrasser og andre belagte arealer",
          "Samlet entreprise: kloak, jord- og gravearbejde under ét tag",
          "Genetablering af græsplæner, belægninger og udendørsarealer",
          "Stabil bundopbygning og professionel komprimering",
          "Kun én kontaktperson og en gennemsigtig tidsplan"
        ],
        "outro": "Uanset opgavens type får du en løsning, der er gennemtænkt, grundig og udført med respekt for både kvalitet og aftaler."
      },
      {
        "type": "local_area",
        "h2": "Din lokale kloakmester i Galten og omegn",
        "paragraphs": [
          "Vi holder til i Galten og kører til opgaver i Hørning, Låsby, Harlev, Hasselager og Skanderborg - men vi dækker selvfølgelig også resten af østjylland. Den lokale placering giver os et godt udgangspunkt for at hjælpe boligejere, virksomheder, landbrug, foreninger og ejendomsansvarlige i området.",
          "Uanset om du har et konkret kloakproblem eller planlægger et større projekt, tager vi udgangspunkt i dine behov og ejendommens forhold. Du får faglig rådgivning fra en erfaren kloakmester, som kan se kloak, udgravning og reetablering som én samlet opgave."
        ],
        "cities": [
          { "name": "Galten", "tag": "Base / Hovedsæde" },
          { "name": "Hørning", "tag": "Lokal dækning" },
          { "name": "Låsby", "tag": "Lokal dækning" },
          { "name": "Harlev", "tag": "Lokal dækning" },
          { "name": "Hasselager", "tag": "Lokal dækning" },
          { "name": "Skanderborg", "tag": "Lokal dækning" }
        ]
      },
      {
        "type": "faq",
        "display_on_page": true,
        "section_heading": {
          "tag": "h2",
          "text": "Ofte stillede spørgsmål om kloakarbejde og priser"
        },
        "items": [
          {
            "question_tag": "h3",
            "question": "Hvad laver en autoriseret kloakmester?",
            "answer_tag": "p",
            "answer": "En autoriseret kloakmester udfører blandt andet etablering, reparation og vedligeholdelse af kloaksystemer efter gældende regler. Entreprenør Jan Hedegaard har over 20 års erfaring, udfører både små og store opgaver og sørger for relevant dokumentation efter arbejdet."
          },
          {
            "question_tag": "h3",
            "question": "Hvornår bør man kontakte et kloakfirma?",
            "answer_tag": "p",
            "answer": "Det kan være relevant at kontakte et kloakfirma ved tilbagevendende stop, dårlig lugt, fugt eller problemer med afløbet. Entreprenør Jan Hedegaard tilbyder kloakservice med grundig undersøgelse og fejlfinding for både private og erhverv."
          },
          {
            "question_tag": "h3",
            "question": "Hvad koster kloakarbejde?",
            "answer_tag": "p",
            "answer": "Prisen på kloakarbejde afhænger blandt andet af opgavens omfang, jordbundsforholdene og behovet for gravearbejde. Entreprenør Jan Hedegaard begynder med en samtale og vurdering af de eksisterende forhold og giver gerne et uforpligtende tilbud på en løsning, der passer til ejendommen."
          },
          {
            "question_tag": "h3",
            "question": "Hvordan finder en kloakmester fejl og skader i kloakken?",
            "answer_tag": "p",
            "answer": "En kloakmester kan benytte TV-inspektion og elektronisk sporing til at lokalisere skader, brønde og rørforløb. Entreprenør Jan Hedegaard anvender grundig fejlfinding som en del af sin kloakservice, så arbejdet kan planlægges ud fra de konkrete forhold."
          },
          {
            "question_tag": "h3",
            "question": "Hvornår er kloakseparering nødvendig?",
            "answer_tag": "p",
            "answer": "Kloakseparering kan være nødvendig efter et kommunalt påbud eller som en forbedring af ejendommens kloaksystem. Entreprenør Jan Hedegaard undersøger forholdene, planlægger en praktisk rørføring og sørger for, at regnvand og spildevand føres i hver sin ledning."
          },
          {
            "question_tag": "h3",
            "question": "Kan én entreprenør og kloakmester udføre hele opgaven?",
            "answer_tag": "p",
            "answer": "Ja, Entreprenør Jan Hedegaard kan samle kloakarbejde med nødvendigt jord- og gravearbejde. Det kan blandt andet omfatte udgravning, dræn, faskiner og efterfølgende reetablering af græsplæne, terrasse eller indkørsel med fokus på stabil bundopbygning og korrekt komprimering."
          },
          {
            "question_tag": "h3",
            "question": "Hvilken dokumentation får man efter udført kloakarbejde?",
            "answer_tag": "p",
            "answer": "Efter udført kloakarbejde sørger Entreprenør Jan Hedegaard som autoriseret kloakmester for den relevante dokumentation. Ved kloakseparering håndterer virksomheden også den nødvendige dokumentation til kommunen."
          }
        ]
      },
      {
        "type": "testimonials",
        "title": "Hvad siger vores kunder?",
        "items": [
          {
            "quote": "Vi vil helt sikkert anbefale folk vi kender at bruge Jan og hans team. De er yderst behagelige og det arbejde de har lavet ved os er super flot.",
            "author": "Simon Lotze",
            "location": "Skanderborg"
          },
          {
            "quote": "Mine naboer har virkelig rost jeres arbejde, og jeg er virkelig glad for min nye indkørsel.",
            "author": "Paul Bridge",
            "location": "Låsby"
          },
          {
            "quote": "Tak for veludført arbejde, det blev en lidt større omgang end forventet men fedt i løste det.",
            "author": "Morten Søgaard",
            "location": "Stavtrup"
          }
        ]
      },
      {
        "type": "contact_section",
        "h2": "Skal vi se nærmere på din opgave",
        "paragraph": "Kontakt Entreprenør Jan Hedegaard, hvis du har brug for en autoriseret kloakmester eller ønsker rådgivning om kloakservice, kloakseparering og andet kloakarbejde. Vi tager en grundig samtale om opgaven og giver gerne et uforpligtende tilbud på den rette løsning."
      }
    ]
  },
  "om-os": {
    "title": "Om Jan Hedegaard | Autoriseret Kloakmester i Galten",
    "meta": {
      "description": "Læs om Entreprenør Jan Hedegaard. Over 20 års erfaring med autoriseret kloakarbejde og entreprenøropgaver i Galten og omegn. Se mere her!",
      "ogTitle": "Om Jan Hedegaard | Autoriseret Kloakmester i Galten",
      "ogDescription": "Læs om Entreprenør Jan Hedegaard. Over 20 års erfaring med autoriseret kloakarbejde og entreprenøropgaver i Galten og omegn. Se mere her!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c48333a8-7cb3-4126-b759-a84656402d0b.jpg",
      "lang": "da-DK"
    },
    "headline": "Entreprenør med fokus på kvalitet, tillid og ordentlighed",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Et alsidigt entreprenørfirma med fokus på kvalitet og aftaler",
        "paragraphs": [
          "Leder du efter en entreprenør i området omkring Skanderborg, Silkeborg, Aarhus eller Horsens? Hos Jan Hedegaard står vi klar til at hjælpe dig med både små og store projekter. Vi er et alsidigt entreprenørfirma med base i Galten – kun 10 minutter fra Aarhus – og vi løser alt fra anlægsopgaver og kloakarbejde til støbning af beton og etablering af ny indkørsel.",
          "Med over 20 års erfaring i branchen har vi oparbejdet en solid faglighed og forståelse for både private og erhvervskunders behov. Som entreprenør sætter vi en ære i at levere løsninger, der holder – og som er tilpasset dine ønsker og budget."
        ]
      },
      {
        "title": "Alsidigt entreprenørfirma der holder, hvad vi lover",
        "paragraphs": [
          "Hos os får du en entreprenør, der står for hele processen fra start til slut. Vi tager os af både kloakarbejde, anlæg, brolægning og betonstøbning – og som autoriseret kloakmester sikrer vi, at alt udføres korrekt og efter gældende regler. Har du brug for hjælp til en ny indkørsel eller et større anlægsprojekt, kan vi levere både rådgivning, udførelse og finish i højeste kvalitet.",
          "Vi er et entreprenørfirma, der går op i kvalitet, præcision og tilfredse kunder. Vi overholder altid vores aftaler og deadlines – og går først fra en opgave, når både du og vi er helt tilfredse. Det betyder, at du trygt kan regne med, at arbejdet bliver udført professionelt og til tiden.",
          "Vores medarbejdere møder dig med et smil, og du kan altid forvente ærlig rådgivning og en service, der bygger på mange års erfaring i faget."
        ]
      },
      {
        "title": "Et samarbejde bygget på dialog og tryghed",
        "paragraphs": [
          "Det vigtigste for os er tillid og åben kommunikation. Når du vælger os som entreprenør, begynder vi altid samarbejdet med en grundig samtale, hvor vi afdækker dine ønsker og behov. Det giver en tryg proces – både for dig som kunde og for os som udførende håndværkere.",
          "Vi ved, at to projekter aldrig er ens, og derfor skræddersyr vi altid løsningen ud fra netop din situation. Gennem tæt dialog og klare aftaler undgår vi misforståelser og sikrer et resultat, du bliver glad for. Hos os handler et godt samarbejde ikke kun om teknik og tidsplaner, men også om respekt for dig, dit hjem og dit projekt."
        ]
      },
      {
        "title": "Få et uforpligtende tilbud – altid til en fair pris",
        "paragraphs": [
          "Når du kontakter os for at få hjælp fra en entreprenør, får du altid et ærligt tilbud og en realistisk pris, der afspejler det håndværk, vi leverer. Vi tror på, at godt arbejde og god dialog går hånd i hånd, og vi hjælper gerne med rådgivning, inden vi går i gang.",
          "Uanset om det gælder et større anlægsarbejde, etablering af kloak, støbning af fundament eller en ny indkørsel, kan du forvente høj kvalitet og et resultat, der holder mange år frem."
        ]
      },
      {
        "title": "Kontakt din lokale entreprenør i dag",
        "paragraphs": [
          "Vil du vide mere om, hvordan vi kan hjælpe dig som entreprenør i Galten og omegn? Kontakt os på (+45) 22 45 85 67 eller send en mail til jan@janhedegaard.dk – så tager vi en uforpligtende snak om din opgave. Vi svarer hurtigt og hjælper dig trygt gennem hele processen fra idé til færdigt projekt."
        ]
      }
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content-1_1.jpg",
        "alt": "Jan Hedegaard - Direktør, Aut. Kloakmester"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content_1.jpg",
        "alt": "Louise - Bogholderi"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content-2.jpg",
        "alt": "Anders - Anlægsstruktør"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content-3_1.jpg",
        "alt": "Skoledreng / Arbejdsdreng - Ungarbejder"
      }
    ]
  },
  "kontakt": {
    "title": "Kontakt Jan Hedegaard | Kloakmester & Entreprenør i Galten",
    "meta": {
      "description": "Har du brug for et uforpligtende tilbud på kloak- eller entreprenørarbejde? Ring på 22 45 85 67 eller send en besked direkte til os her.",
      "ogTitle": "Kontakt Jan Hedegaard | Kloakmester & Entreprenør i Galten",
      "ogDescription": "Har du brug for et uforpligtende tilbud på kloak- eller entreprenørarbejde? Ring på 22 45 85 67 eller send en besked direkte til os her.",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/cfedd232-70ee-41da-a16f-a4d21d9510cb.jpg",
      "lang": "da-DK"
    },
    "headline": "Kontakt",
    "subhead": "Har du spørgsmål eller kommentarer? Kontakt os i dag for at høre mere om, hvad vi kan gøre for dig.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "address": "Søballevej 31, 8464 Galten",
    "addressLink": "https://www.google.com/maps/place/S%C3%B8ballevej%2031,%208464%20Galten",
    "cvr": "45789942",
    "ean": "5790002848186",
    "formTitle": "Skriv til os",
    "formButton": "Send besked"
  },
  "haveservice": {
    "title": "Haveservice & Træfældning i Galten | Jan Hedegaard",
    "meta": {
      "description": "Professionel haveservice, beskæring og topkapning af store træer. Vi hjælper private og virksomheder med havearbejde. Kontakt os i dag!",
      "ogTitle": "Haveservice & Træfældning i Galten | Jan Hedegaard",
      "ogDescription": "Professionel haveservice, beskæring og topkapning af store træer. Vi hjælper private og virksomheder med havearbejde. Kontakt os i dag!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250504-075257394-ios-rotated.jpg",
      "lang": "da-DK"
    },
    "headline": "Haveservice",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Lad os klare opgaven for dig",
    "introText": "I vores grønne afdeling tilbyder vi alle former for grønt vedligehold.",
    "list": [
      "Hækkeklipning",
      "Græsslåning store som små arealer",
      "Beplantning",
      "Beskæring",
      "Gødning/kalkning",
      "Sprøjtning mod ukrudt i græs og på belægning",
      "omlægning/ny etablering af græsplæner",
      "Og meget mere"
    ],
    "outroText": "Vi laver gerne en pasningsaftale med jer så i slipper for at bekymre jer om pasningen af jeres grønne arealer.",
    "treeFelling": {
      "title": "Træfældning og beskæring",
      "subtitle": "Sikker og professionel træfældning med topkapper",
      "paragraphs": [
        "Hos Entreprenør Jan Hedegaard har vi over 15 års erfaring med professionel træfældning, beskæring og haveservice. Vi udfører alle typer opgaver for både private, erhverv og foreninger, uanset om det drejer sig om fældning af store, vanskelige træer tæt på bygninger, eller almindelig vedligeholdelse af grønne områder.",
        "For at sikre den absolut højeste sikkerhed og præcision har vi en professionel topkapper tilknyttet virksomheden. Det betyder, at vi kan klare selv de mest komplicerede og risikofyldte opgaver, hvor træet skal pilles ned i sektioner oppefra, så der ikke sker skade på omkringliggende huse, haver eller el-ledninger.",
        "Vi tilbyder en komplet løsning, hvor vi gerne bortskaffer alt træ og grenaffald efterfølgende. Hvis du ønsker det, kan vi også hjælpe med opskæring til brænde, flishugning på stedet eller være behjælpelige med afsætning af træet. Vi forlader altid din grund pæn, ryddelig og klar til brug."
      ],
      "features": [
        {
          "title": "Sikker topkapning",
          "description": "Vi piller vanskelige træer ned i sektioner oppefra for at beskytte bygninger og omgivelser."
        },
        {
          "title": "15+ års erfaring",
          "description": "Professionelt udstyr, stor ekspertise og fuldt forsikret arbejde for din tryghed."
        },
        {
          "title": "Komplet bortskaffelse",
          "description": "Vi tilbyder flishugning, opskæring til brænde og komplet oprydning efter arbejdet."
        },
        {
          "title": "Beskæring & pleje",
          "description": "Kronereduktion, udtynding og formklipning af træer og buske for optimalt lysindfald."
        }
      ]
    },
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250504-075257394-ios-rotated.jpg",
        "alt": "Bortkørsel af haveaffald og grene på trailer efter beskæring"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/960ae55b-acad-4349-a3fb-4bec42f1b74f.jpg",
        "alt": "Professionel plæneklipning og græsslåning i have"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/25644a9b-47d2-4bbc-851d-05455a89c01c.jpg",
        "alt": "Vedligeholdelse af grønne arealer og buske"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4f97be37-e68a-4276-9717-171ea72a95a9.jpg",
        "alt": "Haveservice og klipning af buske og hæk"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250504-075257394-ios-rotated.jpg",
        "alt": "Flot velplejet have med græsplæne og beplantning"
      }
    ]
  },
  "anlaeg-og-belaegning": {
    "title": "Anlægsarbejde & Brolægning i Galten | Jan Hedegaard",
    "meta": {
      "description": "Skal du have nylagt indkørsel, terrasse eller støttemur? Vi udfører professionelt anlægs- og belægningsarbejde i Østjylland. Få et tilbud!",
      "ogTitle": "Anlægsarbejde & Brolægning i Galten | Jan Hedegaard",
      "ogDescription": "Skal du have nylagt indkørsel, terrasse eller støttemur? Vi udfører professionelt anlægs- og belægningsarbejde i Østjylland. Få et tilbud!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/7544e4c2-59ce-4207-b379-e1dab6e0007b.jpg",
      "lang": "da-DK"
    },
    "headline": "Anlæg og belægning",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Lad os klare opgaven for dig",
    "paragraphs": [
      "I vores anlægsafdeling beskæftiger vi os med nyanlæg af alle former for belægning, brolægning og støttemure.",
      "Et stabilt og langtidsholdbart resultat kræver et korrekt afrettet underlag. Her trækker vi direkte på vores mangeårige erfaring med [entreprenørarbejde](/entreprenoerarbejde) og jordudgravning, så bunden opbygges efter alle kunstens regler.",
      "Vi har en bred viden omkring de forskellige belægninger og rådgiver gerne indenfor området. Skal du have støbt terrasser eller fundamenter i forbindelse med haveprojektet, tilbyder vi også professionel [støbning af beton](/stoebning-af-beton)."
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content_2.jpg",
        "alt": "Flot nylagt fliseterrasse og havegang"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122653119-ios.jpg",
        "alt": "Professionelt belægningsarbejde i indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122657675-ios.jpg",
        "alt": "Nylagte fliser og flot finish"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122700304-ios.jpg",
        "alt": "Flot brolægning og kantafgrænsning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122708965-ios.jpg",
        "alt": "Belægningsprojekt med herregårdssten"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122712413-ios.jpg",
        "alt": "Nylagt indkørsel med flotte detaljer"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122720509-ios.jpg",
        "alt": "Professionel fliselægning og opbygning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122726285-ios.jpg",
        "alt": "Flot haveanlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122737475-ios.jpg",
        "alt": "Flisearbejde og færdigt resultat"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094238603-ios.jpg",
        "alt": "Belægningsarbejde udført af Jan Hedegaard"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094240339-ios.jpg",
        "alt": "Flot ny belægning"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094248782-ios.jpg",
        "alt": "Professionel brolægning og afretning"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094257155-ios.jpg",
        "alt": "Belægning og flisearbejde"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094305297-ios.jpg",
        "alt": "Nylagt indkørsel og fliser"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094313377-ios.jpg",
        "alt": "Præcisionsarbejde med flisebelægning"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094318005-ios.jpg",
        "alt": "Færdigt belægningsprojekt"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094333612-ios.jpg",
        "alt": "Kvalitetsbelægning til have og indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c026ba4a-edd6-40f4-981a-886a35807fd5.jpg",
        "alt": "Terrasse er lagt efter besøg af kloakmester i Hasselager"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/7544e4c2-59ce-4207-b379-e1dab6e0007b.jpg",
        "alt": "Brolægger og kloakmester i Hasselager ved Skanderborg"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/d9638e5f-2807-4453-b782-d422116e01b4.jpg",
        "alt": "Fliser lagt af kloakmester i Skanderborg ved Galten"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/2b04d009-4739-41cf-a28e-1c56fd509f72.jpg",
        "alt": "20250605_100034805_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/2dfe9852-d686-4f99-9498-c60e509e3f03.jpg",
        "alt": "20240629_133549281_iOS"
      }
    ]
  },
  "stoebning-af-beton": {
    "title": "Støbning af Beton & Fundamenter i Galten | Jan Hedegaard",
    "meta": {
      "description": "Korrekt støbning af fundamenter til tilbygninger, garager og haller. Vi sikrer stærkt støbearbejde og stabil bund. Kontakt os for priser!",
      "ogTitle": "Støbning af Beton & Fundamenter i Galten | Jan Hedegaard",
      "ogDescription": "Korrekt støbning af fundamenter til tilbygninger, garager og haller. Vi sikrer stærkt støbearbejde og stabil bund. Kontakt os for priser!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind_1.jpg",
      "lang": "da-DK"
    },
    "headline": "Støbning af beton",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Lad os klare opgaven for dig",
    "introText": "Vi udfører fundamenter til",
    "list": [
      "Tilbygninger",
      "Udestuer",
      "Orangerier",
      "Garager",
      "Landbrugshaller"
    ],
    "paragraphs": [
      "Forud for enhver betonstøbning sørger vi for præcis udgravning og komprimering af bærelaget gennem vores [entreprenørarbejde](/entreprenoerarbejde). Skal projektet afsluttes med fliser eller trapper, klarer vi også den efterfølgende [anlæg og belægning](/anlaeg-og-belaegning).",
      "Hvis du skal have udført andet støbearbejde er vi også behjælpelige, ring gerne for en snak herom.",
      "Står du med planer om en ny tilbygning eller lignende kan vi være behjælpelige med udførelsen. Vi har samarbejdspartnere i alle faggrupper og kan derfor tilrettelægge dit byggeri sammen med dig."
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-094115508-ios_1.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-112212802-ios_1.jpg",
        "alt": "Støbning af terrændæk"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-140238873-ios-1_1.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064551539-ios-1_1.jpg",
        "alt": "Støbning af indkørsel og trappe"
      }
    ]
  },
  "entreprenoerarbejde": {
    "title": "Entreprenørarbejde & Gravearbejde i Galten | Jan Hedegaard",
    "meta": {
      "description": "Professionelt entreprenør- og jordarbejde til udgravning, fundamenter og indkørsler i Østjylland. Få et uforpligtende tilbud på dit projekt!",
      "ogTitle": "Entreprenørarbejde & Gravearbejde i Galten | Jan Hedegaard",
      "ogDescription": "Professionelt entreprenør- og jordarbejde til udgravning, fundamenter og indkørsler i Østjylland. Få et uforpligtende tilbud på dit projekt!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/entr-arbejde1.jpg",
      "lang": "da-DK"
    },
    "headline": "Entreprenørarbejde",
    "subhead": "Vi udfører professionelt jord- og gravearbejde til fundamenter, indkørsler, haver og kloakker med moderne maskiner.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Professionelt jord- og gravearbejde",
        "paragraphs": [
          "Hos Entreprenør Jan Hedegaard tilbyder vi alt inden for entreprenørarbejde med særligt fokus på jord, udgravning og terrænregulering. Vi har mange års erfaring med at forberede byggegrunde, udgrave til [støbning af beton](/stoebning-af-beton) og fundamenter samt flytte store mængder jord effektivt og præcist.",
          "Vi råder over en alsidig og moderne maskinpark, der gør os i stand til at løse både små og store opgaver. Uanset om du skal have klargjort underlaget til [anlæg og belægning](/anlaeg-og-belaegning), planeret haven eller udført gravearbejde til autoriseret [kloakmesterarbejde](/kloakmester-arbejde), leverer vi et solidt stykke arbejde til aftalt tid."
        ]
      },
      {
        "title": "Vi tilbyder blandt andet:",
        "paragraphs": [
          "Vores entreprenørafdeling dækker en bred vifte af ydelser inden for jord- og gravearbejde:"
        ],
        "list": [
          "Udgravning til fundamenter, tilbygninger og garager",
          "Udgravning og bundopbygning til indkørsler, terrasser og stier",
          "Terrænregulering, planering og klargøring til græsplæner",
          "Gravearbejde i forbindelse med kloakering og dræning",
          "Udgravning til faskiner, regnvandsbassiner og søer",
          "Bortkørsel af overskydende jord og levering af grus, sand og muld"
        ],
        "outro": "Vi sikrer altid, at underlaget er fuldstændig stabilt og korrekt komprimeret, så du undgår efterfølgende sætningsskader på dit byggeri eller din belægning."
      },
      {
        "title": "Kvalitet og præcision med den rette maskinpark",
        "paragraphs": [
          "Gravearbejde kræver ikke kun råstyrke, men også stor præcision for at undgå skader på skjulte kabler, rør og omkringliggende bygninger. Vi planlægger altid opgaven grundigt og indhenter LER-oplysninger, inden vi sætter skovlen i jorden.",
          "Med vores erfarne maskinførere bag håndtagene er du sikret et effektivt forløb og et snorlige resultat. Kontakt os i dag for en uforpligtende snak om dit næste graveprojekt."
        ]
      }
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/entr-arbejde1.jpg",
        "alt": "Gravemaskine i gang med jordarbejde"
      }
    ]
  },
  "traefaeldning-og-haveservice": {
    "title": "Træfældning og haveservice | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Træfældning og haveservice | Entreprenør Jan Hedegaard",
      "ogDescription": "Lad os klare opgaven for dig Vi har over 15 års erfaring med træfældning Vi har en topkapper tilknyttet virksomheden så ingen opgaver er for svære for os. Vi bortskaffer gerne træet eller er behjælpelige med afsætning.",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/377d9a9a-0543-4e0b-8aaa-151f691dbed4.jpg",
      "lang": "da-DK"
    },
    "headline": "Træfældning og haveservice",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Lad os klare opgaven for dig",
    "paragraphs": [
      "Hos Entreprenør Jan Hedegaard har vi over 15 års erfaring med professionel træfældning, beskæring og haveservice. Vi udfører alle typer opgaver for både private, erhverv og foreninger, uanset om det drejer sig om fældning af store, vanskelige træer tæt på bygninger, eller almindelig vedligeholdelse af grønne områder.",
      "For at sikre den absolut højeste sikkerhed og præcision har vi en professionel topkapper tilknyttet virksomheden. Det betyder, at vi kan klare selv de mest komplicerede og risikofyldte opgaver, hvor træet skal pilles ned i sektioner oppefra, så der ikke sker skade på omkringliggende huse, haver eller el-ledninger.",
      "Vi tilbyder en komplet løsning, hvor vi gerne bortskaffer alt træ og grenaffald efterfølgende. Hvis du ønsker det, kan vi også hjælpe med opskæring til brænde, flishugning på stedet eller være behjælpelige med afsætning af træet. Vi forlader altid din grund pæn, ryddelig og klar til brug."
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/a1342fde-1896-497a-806b-51039f257f28.jpg",
        "alt": "Professional chainsaw is on walnut tree. Gasoline saw on the felled tree"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/377d9a9a-0543-4e0b-8aaa-151f691dbed4.jpg",
        "alt": "Man with the chain saw in the forest"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/44ca76cf-b18c-43c3-839e-b06494853527.jpg",
        "alt": "Lumberjack using chainsaw while cutting tree in forest."
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/beaaee35-3499-4378-81f6-c05b5114034e.jpg",
        "alt": "man cutting trees using an electrical chainsaw and professional tools"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4b2b5afe-0a69-4c57-93a3-06cb7eb3ce0d.jpg",
        "alt": "20240505_100602045_iOS"
      }
    ]
  },
  "ny-indkoersel": {
    "title": "Ny indkørsel der holder i mange år | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Ny indkørsel der holder i mange år | Entreprenør Jan Hedegaard",
      "ogDescription": "Professionel lægning af indkørsel med fokus på kvalitet og belægning Trænger din gamle indkørsel til en udskiftning – eller skal du have anlagt en helt ny indkørsel ved din bolig i Skanderborg, Silkeborg, Aarhus, Horsens, Bjerringbro eller omegn? Hos Jan Hedegaard får du en løsning, der kombinerer flot design, solidt håndværk og funktionalitet. Som autoriseret ... Læs Mere",
      "lang": "da-DK"
    },
    "headline": "Ny indkørsel der holder i mange år",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind.jpg",
        "alt": "Etablering af ny indkørsel - professionelt brolægningsarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind2.jpg",
        "alt": "Nylagt indkørsel med flotte, præcise belægningssten"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind3.jpg",
        "alt": "Færdigt resultat af flot ny indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-140238873-ios-1_2.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe"
      }
    ],
    "sections": [
      {
        "title": "Professionel lægning af indkørsel med fokus på kvalitet og belægning",
        "paragraphs": [
          "Trænger din gamle indkørsel til en udskiftning – eller skal du have anlagt en helt ny indkørsel ved din bolig i Skanderborg, Silkeborg, Aarhus, Horsens, Bjerringbro eller omegn? Hos Jan Hedegaard får du en løsning, der kombinerer flot design, solidt håndværk og funktionalitet.",
          "Som autoriseret kloakmester og erfaren entreprenør sørger vi for, at både underlaget, drænet og belægningen bliver udført korrekt fra start. Det betyder, at din indkørsel ikke blot bliver pæn, men også holder mange år frem."
        ]
      },
      {
        "title": "Flot flisebelægning og lægning af indkørsel i høj kvalitet",
        "paragraphs": [
          "Vi ved, at en ny indkørsel is an investment in both appearance and value. Therefore, we always work with quality in focus – whether you want classic tiles, modern concrete stones or a unique combination of materials.",
          "Vi tilbyder komplette løsninger inden for:"
        ],
        "list": [
          "Lægning af indkørsel",
          "Flisebelægning og lægning af fliser",
          "Reparation og udvidelse af eksisterende belægning",
          "Professionelt flisearbejde til både private og erhverv"
        ],
        "outro": "Hos os kan du vælge præcis den stil, du ønsker – vi rådgiver dig gerne om farver, mønstre og materialer, så din indkørsel passer perfekt til huset og omgivelserne."
      },
      {
        "title": "Sådan skaber vi en holdbar og smuk ny indkørsel",
        "paragraphs": [
          "En ny indkørsel skal ikke kun se flot ud – den skal også kunne holde til daglig brug og det danske vejr. Derfor sørger vi altid for et solidt underlag, korrekt dræn og den rigtige hældning, så vandet ledes væk fra huset. Vores arbejde med flisebelægning tager højde for både funktion og æstetik, så resultatet bliver lige så praktisk, som det er pænt.",
          "Vi bruger kun materialer af høj kvalitet og udfører alt flisearbejde med stor præcision. Hver belægning bliver lagt med fokus på detaljerne – fra den første udgravning til den sidste fuge. Det giver dig en ny indkørsel, der holder sin form og sit udtryk i mange år uden sætninger eller ujævnheder."
        ]
      },
      {
        "title": "Hvad koster en ny indkørsel?",
        "paragraphs": [
          "Prisen på en ny indkørsel afhænger af flere faktorer – fx underlag, materialer, areal og design. Hos os får du altid en fair pris og et realistisk overslag, der matcher din opgave. Vi tilbyder naturligvis et uforpligtende tilbud, så du på forhånd ved, hvad din investering kommer til at koste.",
          "Vores priser afspejler den høje kvalitet og det grundige arbejde, som vi er kendt for, og vi sørger altid for, at både dræn, fald og underlag bliver udført korrekt, så du undgår problemer på sigt."
        ]
      },
      {
        "title": "Din lokale entreprenør til anlægsarbejde og haveservice",
        "paragraphs": [
          "Når du vælger os til at etablere din ny indkørsel, får du mere end blot en fliseopgave udført. Vi er en erfaren entreprenør, som kan løfte hele projektet – fra udgravning og afretning til belægning og afsluttende detaljer.",
          "Skal indkørslen kombineres med bede, græsplæne eller terrasse, klarer vi også det. Vores afdeling for haveservice hjælper med den sidste finish, så hele udearealet står pænt og indbydende, når vi er færdige.",
          "Vi tager os af alt det praktiske, og du har kun én samarbejdspartner gennem hele processen. Det giver ro i maven – og et resultat, du kan være stolt af."
        ]
      },
      {
        "title": "Kontakt os for et uforpligtende tilbud på din nye indkørsel",
        "paragraphs": [
          "Overvejer du at få anlagt en ny indkørsel? Så er vi klar til at hjælpe. Kontakt os i dag på (+45) 22 45 85 67 eller skriv til jan@janhedegaard.dk – så finder vi sammen den bedste løsning til din grund og dit budget. Vi står klar med rådgivning, belægningsforslag og et uforpligtende tilbud på dit projekt."
        ]
      }
    ]
  },
  "kloakmester-arbejde": {
    "title": "Autoriseret Kloakmesterarbejde i Galten | Jan Hedegaard",
    "meta": {
      "description": "Søger du en erfaren kloakmester? Vi løser alt i nedsivningsanlæg, dræn og autoriseret kloakarbejde for private og erhverv. Kontakt os her!",
      "ogTitle": "Autoriseret Kloakmesterarbejde i Galten | Jan Hedegaard",
      "ogDescription": "Søger du en erfaren kloakmester? Vi løser alt i nedsivningsanlæg, dræn og autoriseret kloakarbejde for private og erhverv. Kontakt os her!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c04241fe-3844-4af5-b58a-5244c3dc4e9b.jpg",
      "lang": "da-DK"
    },
    "headline": "Kloakmester arbejde",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Alt kloakarbejde udføres, ingen opgaver er for små for os",
    "introText": "Hos [Entreprenør Jan Hedegaard](/) har vi mange års erfaring med kloakprojekter, som du også kan se eksempler på i vores billedgalleri.",
    "listTitle": "står du med myndigheds krav om:",
    "list": [
      "Separering",
      "Forbedret rensning af spildevand",
      "Nedsivning af regnvand",
      "Forsinkelse af regnvand"
    ],
    "outroText": "Står du med et myndighedspåbud om [kloakseparering](/kloakseparering), eller har du en kloak der stopper eller driller, så giv os et ring. Vi udfører alle former for professionel [kloakservice](/kloakservice) som autoriseret, lokal kloakmester. Har du problemer med rotter, så er vi autoriserede rottespærremontører.",
    "schema_markup": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilke opgaver må kun udføres af en autoriseret kloakmester?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Alt arbejde på afløbsinstallationer i jorden frem til hovedkloakken er lovpligtigt autorisationskrævende arbejde. Det gælder blandt andet etablering af nye kloakrør, tilslutning til offentlig kloak, reparation af brudte ledninger, montering af rottespærrer, etablering af nedsivningsanlæg, faskiner og separatkloakering. Som autoriseret kloakmester sikrer vi, at alt udføres efter gældende bygningsreglement og miljøkrav."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan foregår fejlfinding ved mistanke om kloakskader eller brud?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Vi anvender professionel TV-inspektion med specialkamera samt elektronisk søgeudstyr/pejling. Hermed kan vi inspicere kloakrørene indefra i fuld HD, lokalisere revner, forskydninger, rødder eller rottehuller, og præcist fastslå skadens placering og dybde. Det sparer unødvendig opgravning af have, indkørsel eller belægning."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad gør jeg, hvis jeg har mistanke om rotter i kloakken?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Opdager du tegn på rotter (f.eks. huller i jorden, lugtgener eller pibende lyde), skal du anmelde det til kommunen, da rottebekæmpelse er lovpligtigt. Som autoriseret kloakmester og certificeret rottespærremontør kan vi foretage en TV-inspektion af rørene for at finde indgangsveje samt montere en godkendt rottespærre i brønden, der forhindrer rotterne i at trænge ind i ejendommen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster kloakmesterarbejde, og hvordan udregnes prisen?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen afhænger af opgavens karakter, rørenes dimensioner og dybde, adgangsforhold på grunden samt behovet for maskinelt gravearbejde og eventuel reetablering. Vi rykker gerne ud, besigtiger forholdene og udarbejder et gennemskueligt og uforpligtende tilbud på forhånd, så du har det fulde overblik."
          }
        },
        {
          "@type": "Question",
          "name": "Håndterer I også gravearbejde og reetablering af have eller belægning?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja, som kombineret entreprenør og kloakmester klarer vi hele processen fra start til slut. Vi indhenter altid LER-oplysninger inden opgravning, udfører det autoriserede kloakarbejde og genetablerer bagefter græsplæne, flisebelægning, indkørsel eller asfalt, så området efterlades i pæneste stand."
          }
        },
        {
          "@type": "Question",
          "name": "Hvilken dokumentation modtager jeg efter udført kloakarbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Efter færdiggørelse af autorisationskrævende kloakarbejde udarbejder vi lovpligtig færdigmelding og kvalitetssikring, herunder as-built tegninger over kloakledninger og brønde. Ved separatkloakering eller påbud indsender vi den nødvendige dokumentation direkte til kommunen, så du har papirerne i orden til BBR og forsikring."
          }
        }
      ]
    },
    "faq": {
      "display_on_page": true,
      "section_heading": {
        "tag": "h2",
        "text": "Ofte stillede spørgsmål om kloakmesterarbejde"
      },
      "items": [
        {
          "question_tag": "h3",
          "question": "Hvilke opgaver må kun udføres af en autoriseret kloakmester?",
          "answer_tag": "p",
          "answer": "Alt arbejde på afløbsinstallationer i jorden frem til hovedkloakken er lovpligtigt autorisationskrævende arbejde. Det gælder blandt andet etablering af nye kloakrør, tilslutning til offentlig kloak, reparation af brudte ledninger, montering af rottespærrer, etablering af nedsivningsanlæg, faskiner og separatkloakering. Som autoriseret kloakmester sikrer vi, at alt udføres efter gældende bygningsreglement og miljøkrav."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan foregår fejlfinding ved mistanke om kloakskader eller brud?",
          "answer_tag": "p",
          "answer": "Vi anvender professionel TV-inspektion med specialkamera samt elektronisk søgeudstyr/pejling. Hermed kan vi inspicere kloakrørene indefra i fuld HD, lokalisere revner, forskydninger, rødder eller rottehuller, og præcist fastslå skadens placering og dybde. Det sparer unødvendig opgravning af have, indkørsel eller belægning."
        },
        {
          "question_tag": "h3",
          "question": "Hvad gør jeg, hvis jeg har mistanke om rotter i kloakken?",
          "answer_tag": "p",
          "answer": "Opdager du tegn på rotter (f.eks. huller i jorden, lugtgener eller pibende lyde), skal du anmelde det til kommunen, da rottebekæmpelse er lovpligtigt. Som autoriseret kloakmester og certificeret rottespærremontør kan vi foretage en TV-inspektion af rørene for at finde indgangsveje samt montere en godkendt rottespærre i brønden, der forhindrer rotterne i at trænge ind i ejendommen."
        },
        {
          "question_tag": "h3",
          "question": "Hvad koster kloakmesterarbejde, og hvordan udregnes prisen?",
          "answer_tag": "p",
          "answer": "Prisen afhænger af opgavens karakter, rørenes dimensioner og dybde, adgangsforhold på grunden samt behovet for maskinelt gravearbejde og eventuel reetablering. Vi rykker gerne ud, besigtiger forholdene og udarbejder et gennemskueligt og uforpligtende tilbud på forhånd, så du har det fulde overblik."
        },
        {
          "question_tag": "h3",
          "question": "Håndterer I også gravearbejde og reetablering af have eller belægning?",
          "answer_tag": "p",
          "answer": "Ja, som kombineret entreprenør og kloakmester klarer vi hele processen fra start til slut. Vi indhenter altid LER-oplysninger inden opgravning, udfører det autoriserede kloakarbejde og genetablerer bagefter græsplæne, flisebelægning, indkørsel eller asfalt, så området efterlades i pæneste stand."
        },
        {
          "question_tag": "h3",
          "question": "Hvilken dokumentation modtager jeg efter udført kloakarbejde?",
          "answer_tag": "p",
          "answer": "Efter færdiggørelse af autorisationskrævende kloakarbejde udarbejder vi lovpligtig færdigmelding og kvalitetssikring, herunder as-built tegninger over kloakledninger og brønde. Ved separatkloakering eller påbud indsender vi den nødvendige dokumentation direkte til kommunen, så du har papirerne i orden til BBR og forsikring."
        }
      ]
    },
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/1126263a-79e8-4e3f-8c49-a4732d1dc0fa.jpg",
        "alt": "20240520_101436868_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/46aaee94-427f-4990-ade2-a7390001b478.jpg",
        "alt": "20240813_123358137_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/cfedd232-70ee-41da-a16f-a4d21d9510cb.jpg",
        "alt": "20250131_082223737_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c04241fe-3844-4af5-b58a-5244c3dc4e9b.jpg",
        "alt": "20241024_114738264_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4a94725b-47a7-4b70-822c-8d5d5b4c8a1d.jpg",
        "alt": "20241022_090911299_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/43586154-92d6-43c8-8757-0c72ffc22dd7.jpg",
        "alt": "20240520_075301115_iOS"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/241f9c13-2ffe-4c28-aa4c-1e603b6db432.jpg",
        "alt": "20230711_074802195_iOS"
      }
    ]
  },
  "ledige-stillinger": {
    "title": "Ledige stillinger | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Ledige stillinger | Entreprenør Jan Hedegaard",
      "ogDescription": "Lad os klare opgaven for dig Vi ansætter desværre ikke i øjeblikket men du er velkommen til at sende en uopfordret ansøgning til jan@janhedegaard.dk Høj kvalitet og god service Hos os kan du altid regne med god service og høj kvalitet. Vi går aldrig fra en opgave, før den 100% færdig, og før begge parter ... Læs Mere",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/5fc0604f-f47c-4a77-b4ac-e33a53e50bd6.jpg",
      "lang": "da-DK"
    },
    "headline": "Ledige stillinger",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Lad os klare opgaven for dig",
        "paragraphs": [
          "Vi ansætter desværre ikke i øjeblikket men du er velkommen til at sende en uopfordret ansøgning til jan@janhedegaard.dk"
        ]
      },
      {
        "title": "Høj kvalitet og god service",
        "paragraphs": [
          "Hos os kan du altid regne med god service og høj kvalitet. Vi går aldrig fra en opgave, før den 100% færdig, og før begge parter er tilfredse med resultatet. Vi overholder alle aftaler og deadlines, så hvis du er på udkig efter kvalitetsløsninger til tiden, så er det os, du skal kontakte.",
          "Vores medarbejdere har den rette faglige viden og kompetencerne til at levere et veludført stykke arbejde. Vi møder dig altid med et smil, og vi besvarer med glæde ethvert spørgsmål, som du måtte have i løbet af projektet."
        ]
      }
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/6d948733-de97-4fe1-b466-c2e6f39345be.jpg",
        "alt": "Terrace clean with the pressure washer"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/44ca76cf-b18c-43c3-839e-b06494853527.jpg",
        "alt": "Lumberjack using chainsaw while cutting tree in forest."
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/5fc0604f-f47c-4a77-b4ac-e33a53e50bd6.jpg",
        "alt": "Garden Brick Pathway Paving by Professional Paver Worker."
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4e68a481-803c-4502-9aeb-35aa3772b88d.jpg",
        "alt": "Male Landscaping Worker Raking Soil And Laying Rolls Of Sod."
      }
    ]
  },
  "galleri": {
    "title": "Galleri | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Galleri | Entreprenør Jan Hedegaard",
      "ogDescription": "Se billeder af vores arbejde Diverse Badeværelse Hovedledning udskiftning Kloakseparering Kloak Omfangsdræn Separering alken",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/cfedd232-70ee-41da-a16f-a4d21d9510cb.jpg",
      "lang": "da-DK"
    },
    "headline": "Galleri",
    "subhead": "Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "introTitle": "Se billeder af vores arbejde",
    "categories": [
      "Diverse",
      "Badeværelse",
      "Hovedledning udskiftning",
      "Kloakseparering",
      "Kloak",
      "Omfangsdræn",
      "Separering alken",
      "Anlæg og belægning",
      "Oprensning, spulning og tankattest",
      "Vand og forsyning",
      "Haveservice",
      "Træfældning og haveservice"
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind.jpg",
        "alt": "Etablering af ny indkørsel - professionelt brolægningsarbejde",
        "category": "Ny indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind2.jpg",
        "alt": "Nylagt indkørsel med flotte, præcise belægningssten",
        "category": "Ny indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind3.jpg",
        "alt": "Færdigt resultat af flot ny indkørsel",
        "category": "Ny indkørsel"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/bela-gning-2.jpeg",
        "alt": "Flot nylagt flisebelægning i indkørsel.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/bela-gning.jpeg",
        "alt": "Professionel udført brolægning og flisearbejde.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094248782-ios_1.jpg",
        "alt": "Etablering af ny belægning og kantsten.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094305297-ios_1.jpg",
        "alt": "Præcisionsarbejde med fliselægning.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094313377-ios_1.jpg",
        "alt": "Forberedelse og afretning af sandpude til belægning.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094333612-ios_1.jpg",
        "alt": "Færdigt resultat af smuk fliseterrasse.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260324-130051882-ios.jpg",
        "alt": "Anlæg af ny indkørsel med herregårdssten.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260324-130100816-ios.jpg",
        "alt": "Detalje af færdig brolægning.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250823-110113708-ios.jpg",
        "alt": "Opbygning af stabilgrus og bundsikring.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251023-085426295-ios.jpg",
        "alt": "Flisearbejde omkring huset.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122653119-ios_1.jpg",
        "alt": "Professionel lægning af store fliser.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122657675-ios_1.jpg",
        "alt": "Afretning af grus inden fliselægning.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122700304-ios_1.jpg",
        "alt": "Klargøring af underlag til ny terrasse.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122708965-ios_1.jpg",
        "alt": "Brolægning i perfekt vater.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122712413-ios_1.jpg",
        "alt": "Etablering af flot gangsti med fliser.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122720509-ios_1.jpg",
        "alt": "Kantafgrænsning og belægningsfinish.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122726285-ios_1.jpg",
        "alt": "Nylagt flisebelægning i havemiljø.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122737475-ios_1.jpg",
        "alt": "Smukt afrundet flisekant og belægning.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content_3.jpg",
        "alt": "Anlæg og belægning af udendørsarealer.",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250927-053948248-ios.jpg",
        "alt": "Oprensning af bæk.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250927-053950969-ios.jpg",
        "alt": "Oprensning af bæk.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250927-054001444-ios.jpg",
        "alt": "Oprensning af bæk.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/have.jpg",
        "alt": "Oprensning af bæk.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250826-084144736-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250826-084155999-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250826-084201876-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250826-115256381-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250826-115257775-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250830-093915103-ios.jpg",
        "alt": "Rydning af skråning for japansk pileurt samt tilplantning af EFU.",
        "category": "Haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251119-081618518-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101339436-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101341914-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101408655-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251212-075508765-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101353328-ios.jpg",
        "alt": "Udskiftning af defekt hovedledning.",
        "category": "Hovedledning udskiftning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250709-062924101-ios.jpg",
        "alt": "Udvidelse af skraldespandsplads.",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/skrald.jpg",
        "alt": "Udvidelse af skraldespandsplads.",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/trampolin.jpeg",
        "alt": "Nedgravning af trampolin",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250720-112449479-ios.jpg",
        "alt": "Nedgravning af trampolin",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250720-100634242-ios.jpeg",
        "alt": "Nedgravning af trampolin",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260225-114602330-ios.jpg",
        "alt": "Opgravet olietank",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/2dfe9852-d686-4f99-9498-c60e509e3f03.jpg",
        "alt": "Diverse",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c026ba4a-edd6-40f4-981a-886a35807fd5.jpg",
        "alt": "Diverse",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251128-184405469-ios.jpg",
        "alt": "TV-inspektion af en ødelagt Ø1000 spildevandsbrønd. Skaden er anmeldt til forsikringen og udbedret for forsikringsselskabet af os.",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251128-184419941-ios.jpg",
        "alt": "TV-inspektion af en ødelagt Ø1000 spildevandsbrønd. Skaden er anmeldt til forsikringen og udbedret for forsikringsselskabet af os.",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250903-074412358-ios_1.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250903-074421600-ios_1.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250903-074911842-ios_1.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-073300097-ios_2.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-082022658-ios_2.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-113502892-ios_2.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-073300097-ios_3.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-082022658-ios_3.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-113502892-ios_3.jpg",
        "alt": "Oprensning, spulning og tankattest.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-111904381-ios-1.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260401-050929240-ios-1.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-121632724-ios.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-104437576-ios.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-104433376-ios-1.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik og fra spildevandssystemet.",
        "category": "Kloakmesterarbejde"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-094115508-ios.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-094125115-ios.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-112212802-ios.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-112219151-ios.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251126-112222605-ios.jpg",
        "alt": "Støbning af terrændæk i kolonihavehus",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260305-063906252-ios.jpg",
        "alt": "Støbning af punktfundamenter for garage",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260305-104906667-ios.jpg",
        "alt": "Støbning af punktfundamenter for garage",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260305-063847465-ios.jpg",
        "alt": "Støbning af punktfundamenter for garage",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260305-063913414-ios.jpg",
        "alt": "Støbning af punktfundamenter for garage",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-140238873-ios-1.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-140236239-ios.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064551539-ios-1.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064559088-ios.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064555066-ios-1.jpg",
        "alt": "Etablering af bund og støbning af indkørsel og trappe",
        "category": "Støbning af beton"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101339436-ios.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101353328-ios.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101341914-ios.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251211-101408655-ios.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251212-075508765-ios.jpg",
        "alt": "Udskiftning af defekt T-stykke i septiktank",
        "category": "Kloak"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/7544e4c2-59ce-4207-b379-e1dab6e0007b.jpg",
        "alt": "Diverse",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/d9638e5f-2807-4453-b782-d422116e01b4.jpg",
        "alt": "Diverse",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4b2b5afe-0a69-4c57-93a3-06cb7eb3ce0d.jpg",
        "alt": "Diverse",
        "category": "Diverse"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/1126263a-79e8-4e3f-8c49-a4732d1dc0fa.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/46aaee94-427f-4990-ade2-a7390001b478.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/cfedd232-70ee-41da-a16f-a4d21d9510cb.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c04241fe-3844-4af5-b58a-5244c3dc4e9b.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/4a94725b-47a7-4b70-822c-8d5d5b4c8a1d.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/43586154-92d6-43c8-8757-0c72ffc22dd7.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/241f9c13-2ffe-4c28-aa4c-1e603b6db432.jpg",
        "alt": "Kloakseparering",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-111904381-ios.jpg",
        "alt": "Udførelse af nye tørledninger så regnvandet kan kobles på forsyningens nye regnvandsstik",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260401-050929240-ios.jpg",
        "alt": "Nye tørledninger etableres til regnvandskobling",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-081038924-ios.jpg",
        "alt": "Regnvand adskilles fra spildevandssystemet med nye rør",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-142016142-ios.jpg",
        "alt": "Udførelse af nye tørledninger til regnvandsstik",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-104433376-ios.jpg",
        "alt": "Nye tørledninger lægges i jorden til regnvand",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-091921375-ios.jpg",
        "alt": "Kloakseparering og tilkobling af regnvand til nyt stik",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260328-074448875-ios.jpg",
        "alt": "Udførelse af nye tørledninger og separering fra spildevand",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094248782-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094305297-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094318005-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094257155-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094333612-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094313377-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094238603-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094240339-ios.jpg",
        "alt": "Tilkobling af kloak til off. kloakstik. Der er lavet pumpebrønd til omfangs-/indstiksdræn og tørledninger til tagnedløbene.",
        "category": "Kloakseparering"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064555066-ios.jpg",
        "alt": "Etablering af bund og kloak til overfladevand",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-140238873-ios.jpg",
        "alt": "Støbning af ny indkørsel og trappe",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064602916-ios.jpg",
        "alt": "Montering af sokkelaffugtere og dræn",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-153123780-ios.jpg",
        "alt": "Klargøring af bund og sandpude til indkørsel",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-153121154-ios.jpg",
        "alt": "Støbning af solid trappe og indgangsparti",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260309-064551539-ios.jpg",
        "alt": "Etablering af kloakering til overfladevand",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20251216-091623056-ios.jpg",
        "alt": "Færdigt resultat med støbt indkørsel og sokkelaffugtere",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/content_2.jpg",
        "alt": "Flot nylagt fliseterrasse og havegang",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122657675-ios.jpg",
        "alt": "Nylagte fliser og flot finish",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122700304-ios.jpg",
        "alt": "Flot brolægning og kantafgrænsning",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122712413-ios.jpg",
        "alt": "Nylagt indkørsel med flotte detaljer",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260527-122720509-ios.jpg",
        "alt": "Professionel fliselægning og opbygning",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094240339-ios.jpg",
        "alt": "Flot ny belægning",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094248782-ios.jpg",
        "alt": "Professionel brolægning og afretning",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094257155-ios.jpg",
        "alt": "Belægning og flisearbejde",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094305297-ios.jpg",
        "alt": "Nylagt indkørsel og fliser",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260522-094313377-ios.jpg",
        "alt": "Præcisionsarbejde med flisebelægning",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c026ba4a-edd6-40f4-981a-886a35807fd5.jpg",
        "alt": "Terrasse er lagt efter besøg af kloakmester i Hasselager",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/7544e4c2-59ce-4207-b379-e1dab6e0007b.jpg",
        "alt": "Brolægger og kloakmester i Hasselager ved Skanderborg",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/d9638e5f-2807-4453-b782-d422116e01b4.jpg",
        "alt": "Fliser lagt af kloakmester i Skanderborg ved Galten",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/2b04d009-4739-41cf-a28e-1c56fd509f72.jpg",
        "alt": "Anlagt fliseareal og præcist belægningsarbejde ved ejendom",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/2dfe9852-d686-4f99-9498-c60e509e3f03.jpg",
        "alt": "Nybelagt terrasse og havegang med udskæring omkring trappe og murværk",
        "category": "Anlæg og belægning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-073300097-ios_1.jpg",
        "alt": "Oprensning af tank og kloaksystem",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-082022658-ios_1.jpg",
        "alt": "Spulning af kloakledninger",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-082034169-ios_1.jpg",
        "alt": "Inspektion og klargøring til tankattest",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260415-082042229-ios_1.jpg",
        "alt": "Professionel spulning og oprensning",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-111821433-ios_1.jpg",
        "alt": "Udstyr til oprensning og spulning",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-111824424-ios_1.jpg",
        "alt": "Kloakspulning i gang",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-113502892-ios_1.jpg",
        "alt": "Kontrol af tank og rørledninger",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-122609589-ios_1.jpg",
        "alt": "Oprensning af bundfældningstank",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260416-123638968-ios_1.jpg",
        "alt": "Færdigt arbejde og klar til tankattest",
        "category": "Oprensning, spulning og tankattest"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250621-084952485-ios.jpeg",
        "alt": "Etablering af vandledning for hestestald.",
        "category": "Vand og forsyning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250621-095423615-ios.jpeg",
        "alt": "Etablering af vandledning for hestestald.",
        "category": "Vand og forsyning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/hest.jpeg",
        "alt": "Etablering af vandledning for hestestald.",
        "category": "Vand og forsyning"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/beaaee35-3499-4378-81f6-c05b5114034e.jpg",
        "alt": "Professionel træfældning og beskæring med motorsav",
        "category": "Træfældning og haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/44ca76cf-b18c-43c3-839e-b06494853527.jpg",
        "alt": "Sikker fældning af store træer i tæt bebyggelse",
        "category": "Træfældning og haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/377d9a9a-0543-4e0b-8aaa-151f691dbed4.jpg",
        "alt": "Præcisionstopkapning og beskæring af høje træer",
        "category": "Træfældning og haveservice"
      },
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/a1342fde-1896-497a-806b-51039f257f28.jpg",
        "alt": "Bortskaffelse og opskæring af fældet træ",
        "category": "Træfældning og haveservice"
      }
    ]
  },
  "anlaeg-og-brolaegning": {
    "title": "Siden blev ikke fundet | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Siden blev ikke fundet | Entreprenør Jan Hedegaard",
      "lang": "da-DK"
    },
    "headline": "404",
    "subhead": "Ups! Den side, du leder efter, findes ikke.",
    "text": "Vend tilbage til forsiden ved at bruge knappen herunder. Giv os besked, hvis problemet fortsætter. Tak!",
    "buttonText": "Gå tilbage",
    "buttonHref": "/"
  },
  "kloakseparering": {
    "title": "Kloakseparering i Galten & Skanderborg | Jan Hedegaard",
    "meta": {
      "description": "Har du fået påbud om separering af regn- og spildevand? Autoriseret kloakmester håndterer hele processen inkl. myndighedsgodkendelse. Få tilbud!",
      "ogTitle": "Kloakseparering i Galten & Skanderborg | Jan Hedegaard",
      "ogDescription": "Har du fået påbud om separering af regn- og spildevand? Autoriseret kloakmester håndterer hele processen inkl. myndighedsgodkendelse. Få tilbud!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios-1.jpg",
      "lang": "da-DK"
    },
    "headline": "Kloakseparering",
    "subhead": "Har du fået et påbud om at adskille regnvand og spildevand, hjælper vi dig sikkert gennem hele opgaven. [Entreprenør Jan Hedegaard](/) udfører kloakseparering i Galten og omegn for både private og erhverv. Du får en autoriseret kloakmester med over 20 års erfaring og en løsning tilpasset din ejendom.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Hvad er separatkloakering, og hvorfor bliver den nødvendig?",
        "paragraphs": [
          "Separatkloakering betyder, at regnvand og spildevand ikke længere løber i samme ledning. Spildevandet føres til rensning, mens regnvandet ledes til den løsning, der gælder for området eller håndteres lokalt, når forholdene og myndighedernes krav giver mulighed for det.",
          "Et kommunalt påbud beskriver normalt, hvad der skal ændres på din grund, og hvornår arbejdet skal være færdigt. Det er vigtigt at få undersøgt rørføringen i god tid, så løsningen kan planlægges korrekt og tilpasses både kloaksystemet, bygningerne og de arealer, der bliver berørt."
        ],
        "list": [
          "Mindre belastning af kloaksystemet, når store mængder regn ikke blandes med spildevandet.",
          "Bedre forhold for rensning, fordi renseanlægget ikke modtager samme mængde regnvand fra ejendommen.",
          "En løsning, der kan mindske risikoen for overbelastning og opstuvning under kraftig regn."
        ]
      },
      {
        "title": "Sådan planlægger vi kloak separering på din grund",
        "paragraphs": [
          "Uanset om opgaven er beskrevet som kloak separering eller separatkloakering, starter vi med en grundig samtale om din ejendom og dit påbud. Vi ser på dine ønsker, de praktiske forhold og økonomien, så du får et klart overblik over opgaven, inden gravearbejdet begynder."
        ],
        "subsections": [
          {
            "title": "Først kortlægger vi det eksisterende kloaksystem",
            "paragraphs": [
              "Vi undersøger de nuværende ledninger, brønde og afløb og bruger TV inspektion eller elektronisk sporing, når det er relevant. Det giver et bedre grundlag for at placere de nye rør. Før gravearbejdet indhenter vi LER oplysninger, så risikoen for at beskadige skjulte kabler og ledninger reduceres."
            ]
          },
          {
            "title": "Derefter udfører og dokumenterer vi arbejdet",
            "paragraphs": [
              "Når planen er på plads, etablerer vi separate rør til regnvand og spildevand. Vi arbejder med fokus på mindst mulig påvirkning af have, belægning og indkørsel. Efter udførelsen sørger vi for den relevante dokumentation og reetablerer de berørte arealer efter den aftalte løsning."
            ]
          }
        ]
      },
      {
        "title": "Kloakseparering pris, hvad påvirker dit tilbud?",
        "paragraphs": [
          "Prisen på kloakseparering afhænger af forholdene på netop din grund. To ejendomme på samme vej kan kræve forskellige løsninger, fordi rørene ligger i forskellig dybde, eller fordi adgangsforhold, jordbund og belægning varierer. Derfor giver en besigtigelse et mere retvisende grundlag for tilbuddet."
        ],
        "list": [
          "Længden, dybden og placeringen af de nye kloakledninger.",
          "Jordbund, adgangsforhold og plads til maskiner på grunden.",
          "Den valgte løsning til bortledning eller lokal håndtering af regnvand.",
          "Behovet for reetablering af græs, fliser, terrasse eller indkørsel."
        ],
        "outro": "Vi gennemgår opgaven med dig og aftaler, hvad der skal indgå, før arbejdet sættes i gang. På den måde bliver din kloakseparering pris baseret på den faktiske løsning frem for et usikkert standardbeløb. Du kan kontakte os for en uforpligtende samtale og et tilbud på din ejendom."
      },
      {
        "title": "Autoriseret arbejde giver dig den nødvendige dokumentation",
        "paragraphs": [
          "Den autorisationskrævende del af arbejdet skal udføres korrekt efter gældende regler. Som autoriseret kloakmester kan vi stå for både undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation. Det giver en sammenhængende proces med klare aftaler fra første gennemgang til færdig reetablering."
        ]
      },
      {
        "title": "Lokal kloakseparering i Galten og resten af nærområdet",
        "paragraphs": [
          "Vi har base i Galten og udfører kloakseparering i Skanderborg, Hørning, Låsby, Harlev og Hasselager. Vores erfaring som både entreprenør og kloakmester betyder, at vi kan håndtere flere dele af projektet og tilpasse arbejdet til adgangsforholdene, haven og de eksisterende belægninger.",
          "Har du fået et påbud, eller vil du vide, om dit kloaksystem er klar til separatkloakering, tager vi gerne en grundig snak om mulighederne. Oplever du akutte udfordringer med tilstoppede rør eller lugtgener forud for projektet, kan vi også assistere med alsidig [kloakservice](/kloakservice). Kontakt Entreprenør Jan Hedegaard, så ser vi på forholdene og finder en praktisk løsning, der passer til din ejendom og kommunens krav."
        ]
      }
    ],
    "faq": {
      "display_on_page": true,
      "section_heading": {
        "tag": "h2",
        "text": "Ofte stillede spørgsmål"
      },
      "items": [
        {
          "question_tag": "h3",
          "question": "Hvad er separatkloakering, og hvorfor bliver det nødvendigt?",
          "answer_tag": "p",
          "answer": "Separatkloakering betyder, at regnvand og spildevand føres i hver sin ledning. Det kan blive nødvendigt som følge af et kommunalt påbud og kan mindske belastningen af kloaksystemet samt risikoen for overbelastning under kraftig regn. Entreprenør Jan Hedegaard undersøger forholdene på ejendommen og tilpasser løsningen til kloaksystemet, bygningerne og myndighedernes krav."
        },
        {
          "question_tag": "h3",
          "question": "Er kloak separering og separatkloakering det samme?",
          "answer_tag": "p",
          "answer": "Ja, kloak separering og separatkloakering bruges om arbejdet med at adskille regnvand fra spildevand. Entreprenør Jan Hedegaard planlægger arbejdet ud fra ejendommens eksisterende rørføring, det eventuelle påbud, de praktiske forhold og kundens ønsker."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan foregår kloakseparering på en ejendom?",
          "answer_tag": "p",
          "answer": "Entreprenør Jan Hedegaard starter kloakseparering med en samtale og en gennemgang af ejendommen. Ledninger, brønde og afløb kortlægges, og der anvendes TV-inspektion eller elektronisk sporing, når det er relevant. Derefter indhentes LER-oplysninger, separate rør etableres, og arbejdet afsluttes med relevant dokumentation og aftalt reetablering."
        },
        {
          "question_tag": "h3",
          "question": "Hvad påvirker en kloakseparering pris?",
          "answer_tag": "p",
          "answer": "En kloakseparering pris afhænger blandt andet af rørenes længde og dybde, jordbunden, adgangsforholdene, pladsen til maskiner og den valgte løsning til regnvand. Behovet for reetablering af græs, fliser, terrasse eller indkørsel har også betydning. Entreprenør Jan Hedegaard besigtiger derfor ejendommen og baserer tilbuddet på den konkrete løsning frem for et usikkert standardbeløb."
        },
        {
          "question_tag": "h3",
          "question": "Hvem må udføre kloakseparering?",
          "answer_tag": "p",
          "answer": "Den autorisationskrævende del af en kloakseparering skal udføres korrekt efter gældende regler. Entreprenør Jan Hedegaard er autoriseret kloakmester og kan stå for undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation gennem hele processen."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan begrænses skader på have, belægning og indkørsel ved separatkloakering?",
          "answer_tag": "p",
          "answer": "Arbejdet planlægges ud fra ledningernes placering, adgangsforholdene og de arealer, der bliver berørt. Entreprenør Jan Hedegaard udfører arbejdet med fokus på mindst mulig påvirkning af have, belægning og indkørsel og reetablerer efterfølgende arealerne i overensstemmelse med den aftalte løsning."
        },
        {
          "question_tag": "h3",
          "question": "Hvad skal man gøre efter et påbud om kloakseparering?",
          "answer_tag": "p",
          "answer": "Et påbud beskriver normalt, hvad der skal ændres på grunden, og hvornår arbejdet skal være afsluttet. Det er en fordel at få rørføringen undersøgt i god tid. Entreprenør Jan Hedegaard gennemgår påbuddet og ejendommens forhold, så arbejdet kan planlægges efter kloaksystemet, de berørte arealer og kommunens krav."
        }
      ]
    },
    "schema_markup": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvad er separatkloakering, og hvorfor bliver det nødvendigt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Separatkloakering betyder, at regnvand og spildevand føres i hver sin ledning. Det kan blive nødvendigt som følge af et kommunalt påbud og kan mindske belastningen af kloaksystemet samt risikoen for overbelastning under kraftig regn. Entreprenør Jan Hedegaard undersøger forholdene på ejendommen og tilpasser løsningen til kloaksystemet, bygningerne og myndighedernes krav."
          }
        },
        {
          "@type": "Question",
          "name": "Er kloak separering og separatkloakering det samme?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja, kloak separering og separatkloakering bruges om arbejdet med at adskille regnvand fra spildevand. Entreprenør Jan Hedegaard planlægger arbejdet ud fra ejendommens eksisterende rørføring, det eventuelle påbud, de praktiske forhold og kundens ønsker."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan foregår kloakseparering på en ejendom?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Entreprenør Jan Hedegaard starter kloakseparering med en samtale og en gennemgang af ejendommen. Ledninger, brønde og afløb kortlægges, og der anvendes TV-inspektion eller elektronisk sporing, når det er relevant. Derefter indhentes LER-oplysninger, separate rør etableres, og arbejdet afsluttes med relevant dokumentation og aftalt reetablering."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad påvirker en kloakseparering pris?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En kloakseparering pris afhænger blandt andet af rørenes længde og dybde, jordbunden, adgangsforholdene, pladsen til maskiner og den valgte løsning til regnvand. Behovet for reetablering af græs, fliser, terrasse eller indkørsel har også betydning. Entreprenør Jan Hedegaard besigtiger derfor ejendommen og baserer tilbuddet på den konkrete løsning frem for et usikkert standardbeløb."
          }
        },
        {
          "@type": "Question",
          "name": "Hvem må udføre kloakseparering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Den autorisationskrævende del af en kloakseparering skal udføres korrekt efter gældende regler. Entreprenør Jan Hedegaard er autoriseret kloakmester og kan stå for undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation gennem hele processen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan begrænses skader på have, belægning og indkørsel ved separatkloakering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Arbejdet planlægges ud fra ledningernes placering, adgangsforholdene og de arealer, der bliver berørt. Entreprenør Jan Hedegaard udfører arbejdet med fokus på mindst mulig påvirkning af have, belægning og indkørsel og reetablerer efterfølgende arealerne i overensstemmelse med den aftalte løsning."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad skal man gøre efter et påbud om kloakseparering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Et påbud beskriver normalt, hvad der skal ændres på grunden, og hvornår arbejdet skal være afsluttet. Det er en fordel at få rørføringen undersøgt i god tid. Entreprenør Jan Hedegaard gennemgår påbuddet og ejendommens forhold, så arbejdet kan planlægges efter kloaksystemet, de berørte arealer og kommunens krav."
          }
        }
      ]
    },
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios-1.jpg",
        "alt": "Kloakseparering og lægning af rør i jorden"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/87ce90a0-232a-492f-b770-fb9275798d1e.jpg",
        "alt": "Gravemaskine i gang med kloakarbejde"
      }
    ]
  },
  "kloak-separering": {
    "title": "Kloakseparering i Galten og omegn | Få den rette løsning nu",
    "meta": {
      "description": "Få kloakseparering udført af en autoriseret kloakmester med over 20 års erfaring. Vi sikrer en løsning til din ejendom - kontakt os for et tilbud.",
      "ogTitle": "Kloakseparering i Galten og omegn | Få den rette løsning nu",
      "ogDescription": "Få kloakseparering udført af en autoriseret kloakmester med over 20 års erfaring. Vi sikrer en løsning til din ejendom - kontakt os for et tilbud.",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios-1.jpg",
      "lang": "da-DK"
    },
    "headline": "Kloakseparering",
    "subhead": "Har du fået et påbud om at adskille regnvand og spildevand, hjælper vi dig sikkert gennem hele opgaven. [Entreprenør Jan Hedegaard](/) udfører kloakseparering i Galten og omegn for både private og erhverv. Du får en autoriseret kloakmester med over 20 års erfaring og en løsning tilpasset din ejendom.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Hvad er separatkloakering, og hvorfor bliver den nødvendig?",
        "paragraphs": [
          "Separatkloakering betyder, at regnvand og spildevand ikke længere løber i samme ledning. Spildevandet føres til rensning, mens regnvandet ledes til den løsning, der gælder for området eller håndteres lokalt, når forholdene og myndighedernes krav giver mulighed for det.",
          "Et kommunalt påbud beskriver normalt, hvad der skal ændres på din grund, og hvornår arbejdet skal være færdigt. Det er vigtigt at få undersøgt rørføringen i god tid, så løsningen kan planlægges korrekt og tilpasses både kloaksystemet, bygningerne og de arealer, der bliver berørt."
        ],
        "list": [
          "Mindre belastning af kloaksystemet, når store mængder regn ikke blandes med spildevandet.",
          "Bedre forhold for rensning, fordi renseanlægget ikke modtager samme mængde regnvand fra ejendommen.",
          "En løsning, der kan mindske risikoen for overbelastning og opstuvning under kraftig regn."
        ]
      },
      {
        "title": "Sådan planlægger vi kloak separering på din grund",
        "paragraphs": [
          "Uanset om opgaven er beskrevet som kloak separering eller separatkloakering, starter vi med en grundig samtale om din ejendom og dit påbud. Vi ser på dine ønsker, de praktiske forhold og økonomien, så du får et klart overblik over opgaven, inden gravearbejdet begynder."
        ],
        "subsections": [
          {
            "title": "Først kortlægger vi det eksisterende kloaksystem",
            "paragraphs": [
              "Vi undersøger de nuværende ledninger, brønde og afløb og bruger TV inspektion eller elektronisk sporing, når det er relevant. Det giver et bedre grundlag for at placere de nye rør. Før gravearbejdet indhenter vi LER oplysninger, så risikoen for at beskadige skjulte kabler og ledninger reduceres."
            ]
          },
          {
            "title": "Derefter udfører og dokumenterer vi arbejdet",
            "paragraphs": [
              "Når planen er på plads, etablerer vi separate rør til regnvand og spildevand. Vi arbejder med fokus på mindst mulig påvirkning af have, belægning og indkørsel. Efter udførelsen sørger vi for den relevante dokumentation og reetablerer de berørte arealer efter den aftalte løsning."
            ]
          }
        ]
      },
      {
        "title": "Kloakseparering pris, hvad påvirker dit tilbud?",
        "paragraphs": [
          "Prisen på kloakseparering afhænger af forholdene på netop din grund. To ejendomme på samme vej kan kræve forskellige løsninger, fordi rørene ligger i forskellig dybde, eller fordi adgangsforhold, jordbund og belægning varierer. Derfor giver en besigtigelse et mere retvisende grundlag for tilbuddet."
        ],
        "list": [
          "Længden, dybden og placeringen af de nye kloakledninger.",
          "Jordbund, adgangsforhold og plads til maskiner på grunden.",
          "Den valgte løsning til bortledning eller lokal håndtering af regnvand.",
          "Behovet for reetablering af græs, fliser, terrasse eller indkørsel."
        ],
        "outro": "Vi gennemgår opgaven med dig og aftaler, hvad der skal indgå, før arbejdet sættes i gang. På den måde bliver din kloakseparering pris baseret på den faktiske løsning frem for et usikkert standardbeløb. Du kan kontakte os for en uforpligtende samtale og et tilbud på din ejendom."
      },
      {
        "title": "Autoriseret arbejde giver dig den nødvendige dokumentation",
        "paragraphs": [
          "Den autorisationskrævende del af arbejdet skal udføres korrekt efter gældende regler. Som autoriseret kloakmester kan vi stå for både undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation. Det giver en sammenhængende proces med klare aftaler fra første gennemgang til færdig reetablering."
        ]
      },
      {
        "title": "Lokal kloakseparering i Galten og resten af nærområdet",
        "paragraphs": [
          "Vi har base i Galten og udfører kloakseparering i Skanderborg, Hørning, Låsby, Harlev og Hasselager. Vores erfaring som både entreprenør og kloakmester betyder, at vi kan håndtere flere dele af projektet og tilpasse arbejdet til adgangsforholdene, haven og de eksisterende belægninger.",
          "Har du fået et påbud, eller vil du vide, om dit kloaksystem er klar til separatkloakering, tager vi gerne en grundig snak om mulighederne. Kontakt Entreprenør Jan Hedegaard, så ser vi på forholdene og finder en praktisk løsning, der passer til din ejendom og kommunens krav."
        ]
      }
    ],
    "faq": {
      "display_on_page": true,
      "section_heading": {
        "tag": "h2",
        "text": "Ofte stillede spørgsmål"
      },
      "items": [
        {
          "question_tag": "h3",
          "question": "Hvad er separatkloakering, og hvorfor bliver det nødvendigt?",
          "answer_tag": "p",
          "answer": "Separatkloakering betyder, at regnvand og spildevand føres i hver sin ledning. Det kan blive nødvendigt som følge af et kommunalt påbud og kan mindske belastningen af kloaksystemet samt risikoen for overbelastning under kraftig regn. Entreprenør Jan Hedegaard undersøger forholdene på ejendommen og tilpasser løsningen til kloaksystemet, bygningerne og myndighedernes krav."
        },
        {
          "question_tag": "h3",
          "question": "Er kloak separering og separatkloakering det samme?",
          "answer_tag": "p",
          "answer": "Ja, kloak separering og separatkloakering bruges om arbejdet med at adskille regnvand fra spildevand. Entreprenør Jan Hedegaard planlægger arbejdet ud fra ejendommens eksisterende rørføring, det eventuelle påbud, de praktiske forhold og kundens ønsker."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan foregår kloakseparering på en ejendom?",
          "answer_tag": "p",
          "answer": "Entreprenør Jan Hedegaard starter kloakseparering med en samtale og en gennemgang af ejendommen. Ledninger, brønde og afløb kortlægges, og der anvendes TV-inspektion eller elektronisk sporing, når det er relevant. Derefter indhentes LER-oplysninger, separate rør etableres, og arbejdet afsluttes med relevant dokumentation og aftalt reetablering."
        },
        {
          "question_tag": "h3",
          "question": "Hvad påvirker en kloakseparering pris?",
          "answer_tag": "p",
          "answer": "En kloakseparering pris afhænger blandt andet af rørenes længde og dybde, jordbunden, adgangsforholdene, pladsen til maskiner og den valgte løsning til regnvand. Behovet for reetablering af græs, fliser, terrasse eller indkørsel har også betydning. Entreprenør Jan Hedegaard besigtiger derfor ejendommen og baserer tilbuddet på den konkrete løsning frem for et usikkert standardbeløb."
        },
        {
          "question_tag": "h3",
          "question": "Hvem må udføre kloakseparering?",
          "answer_tag": "p",
          "answer": "Den autorisationskrævende del af en kloakseparering skal udføres korrekt efter gældende regler. Entreprenør Jan Hedegaard er autoriseret kloakmester og kan stå for undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation gennem hele processen."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan begrænses skader på have, belægning og indkørsel ved separatkloakering?",
          "answer_tag": "p",
          "answer": "Arbejdet planlægges ud fra ledningernes placering, adgangsforholdene og de arealer, der bliver berørt. Entreprenør Jan Hedegaard udfører arbejdet med fokus på mindst mulig påvirkning af have, belægning og indkørsel og reetablerer efterfølgende arealerne i overensstemmelse med den aftalte løsning."
        },
        {
          "question_tag": "h3",
          "question": "Hvad skal man gøre efter et påbud om kloakseparering?",
          "answer_tag": "p",
          "answer": "Et påbud beskriver normalt, hvad der skal ændres på grunden, og hvornår arbejdet skal være afsluttet. Det er en fordel at få rørføringen undersøgt i god tid. Entreprenør Jan Hedegaard gennemgår påbuddet og ejendommens forhold, så arbejdet kan planlægges efter kloaksystemet, de berørte arealer og kommunens krav."
        }
      ]
    },
    "schema_markup": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvad er separatkloakering, og hvorfor bliver det nødvendigt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Separatkloakering betyder, at regnvand og spildevand føres i hver sin ledning. Det kan blive nødvendigt som følge af et kommunalt påbud og kan mindske belastningen af kloaksystemet samt risikoen for overbelastning under kraftig regn. Entreprenør Jan Hedegaard undersøger forholdene på ejendommen og tilpasser løsningen til kloaksystemet, bygningerne og myndighedernes krav."
          }
        },
        {
          "@type": "Question",
          "name": "Er kloak separering og separatkloakering det samme?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja, kloak separering og separatkloakering bruges om arbejdet med at adskille regnvand fra spildevand. Entreprenør Jan Hedegaard planlægger arbejdet ud fra ejendommens eksisterende rørføring, det eventuelle påbud, de praktiske forhold og kundens ønsker."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan foregår kloakseparering på en ejendom?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Entreprenør Jan Hedegaard starter kloakseparering med en samtale og en gennemgang af ejendommen. Ledninger, brønde og afløb kortlægges, og der anvendes TV-inspektion eller elektronisk sporing, når det er relevant. Derefter indhentes LER-oplysninger, separate rør etableres, og arbejdet afsluttes med relevant dokumentation og aftalt reetablering."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad påvirker en kloakseparering pris?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En kloakseparering pris afhænger blandt andet af rørenes længde og dybde, jordbunden, adgangsforholdene, pladsen til maskiner og den valgte løsning til regnvand. Behovet for reetablering af græs, fliser, terrasse eller indkørsel har også betydning. Entreprenør Jan Hedegaard besigtiger derfor ejendommen og baserer tilbuddet på den konkrete løsning frem for et usikkert standardbeløb."
          }
        },
        {
          "@type": "Question",
          "name": "Hvem må udføre kloakseparering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Den autorisationskrævende del af en kloakseparering skal udføres korrekt efter gældende regler. Entreprenør Jan Hedegaard er autoriseret kloakmester og kan stå for undersøgelse, gravearbejde, nye installationer og den nødvendige dokumentation gennem hele processen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan begrænses skader på have, belægning og indkørsel ved separatkloakering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Arbejdet planlægges ud fra ledningernes placering, adgangsforholdene og de arealer, der bliver berørt. Entreprenør Jan Hedegaard udfører arbejdet med fokus på mindst mulig påvirkning af have, belægning og indkørsel og reetablerer efterfølgende arealerne i overensstemmelse med den aftalte løsning."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad skal man gøre efter et påbud om kloakseparering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Et påbud beskriver normalt, hvad der skal ændres på grunden, og hvornår arbejdet skal være afsluttet. Det er en fordel at få rørføringen undersøgt i god tid. Entreprenør Jan Hedegaard gennemgår påbuddet og ejendommens forhold, så arbejdet kan planlægges efter kloaksystemet, de berørte arealer og kommunens krav."
          }
        }
      ]
    },
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios-1.jpg",
        "alt": "Kloakseparering og lægning af rør i jorden"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/87ce90a0-232a-492f-b770-fb9275798d1e.jpg",
        "alt": "Gravemaskine i gang med kloakarbejde"
      }
    ]
  },
  "kloakservice": {
    "title": "Kloakservice, Spuling & Fejlfinding i Galten | Jan Hedegaard",
    "meta": {
      "description": "Akut eller forebyggende kloakservice? Vi tilbyder effektiv kloakrensning, spuling og fejlsøgning af stoppede afløb. Ring til os i dag!",
      "ogTitle": "Kloakservice, Spuling & Fejlfinding i Galten | Jan Hedegaard",
      "ogDescription": "Akut eller forebyggende kloakservice? Vi tilbyder effektiv kloakrensning, spuling og fejlsøgning af stoppede afløb. Ring til os i dag!",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-070815450-ios.jpg",
      "lang": "da-DK"
    },
    "headline": "Kloakservice",
    "subhead": "Har du et afløb, der løber langsomt, lugt fra kloakken eller problemer, som bliver ved med at vende tilbage? Hos [Entreprenør Jan Hedegaard](/) får du kloakservice udført af en autoriseret kloakmester med over 20 års erfaring. Vi hjælper både private og erhverv med små og store opgaver.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Er din kloak ved at give problemer?",
        "paragraphs": [
          "En tilstoppet kloak viser sig ofte ved langsomme afløb, gurglende lyde, dårlig lugt eller vand, der ikke løber væk som normalt. Det kan være tegn på en blokering, men også på skader eller fejl i rørene. Derfor undersøger vi årsagen, før vi anbefaler den rette løsning.",
          "Det er en god ide at reagere, inden et mindre problem udvikler sig og giver fugt eller oversvømmelse. Vi tilpasser vores kloakservice til forholdene på ejendommen og taler opgaven grundigt igennem med dig, så du ved, hvad der skal ske, og hvilke dele af arealet der bliver berørt."
        ]
      },
      {
        "title": "Hvad kan vores kloakservice hjælpe med?",
        "paragraphs": [
          "Vi udfører kloakarbejde med udgangspunkt i det konkrete problem og kloaksystemets tilstand. Nogle gange er en grundig kloakrensning nok, mens andre opgaver kræver fejlfinding, kloakspuling eller reparation. Du får en faglig vurdering frem for en løsning valgt på forhånd."
        ],
        "list": [
          "Kloakrensning ved blokeringer og tilbagevendende problemer",
          "Kloakspuling, som løsner snavs og aflejringer i rørene",
          "Inspektion med kamera og elektronisk sporing af rør og brønde",
          "Kloakrenovering ved beskadigede eller nedslidte installationer",
          "Autoriseret kloakarbejde ved ændringer og nye installationer"
        ],
        "subsections": [
          {
            "title": "Kloakspuling og kloakrensning skaber fri passage",
            "paragraphs": [
              "Ved kloakspuling føres vand gennem rørene under tryk, så fastsiddende snavs og aflejringer løsnes og skylles væk. Kloakrensning kan være relevant ved en konkret prop eller som del af arbejdet med tilbagevendende problemer. Metoden vælges altid efter rørenes tilstand og problemets karakter.",
              "Når vandet igen kan passere, er det stadig vigtigt at vurdere, hvorfor problemet opstod. Hvis afløbet ofte stopper, eller lugtgenerne kommer tilbage, kan en målrettet [TV-inspektion](/tv-inspektion) med kamera vise forskydninger, brud eller andre forhold, som en almindelig rensning ikke løser."
            ]
          },
          {
            "title": "Hvornår er kloakrenovering den rigtige løsning?",
            "paragraphs": [
              "Kloakrenovering bliver relevant, når rørene har skader, er nedslidte eller ikke længere fungerer efter hensigten. Vi undersøger installationerne og rådgiver om reparation eller udskiftning ud fra de faktiske forhold. Hvis der skal graves, kan vi også håndtere jordarbejde og efterfølgende reetablering. Står du samtidig over for krav om adskillelse af regn- og spildevand, udfører vi også komplet [kloakseparering](/kloakseparering) på ejendommen."
            ]
          }
        ]
      },
      {
        "title": "Sådan går vi fra symptom til holdbar løsning",
        "paragraphs": [
          "En god løsning begynder med korrekt fejlfinding. Vi ser på symptomerne, gennemgår de kendte forhold og bruger kamera samt elektronisk sporing, når det er relevant. Det giver et bedre grundlag for at planlægge arbejdet og begrænse unødig påvirkning af have, fliser eller indkørsel."
        ],
        "list": [
          "Vi taler med dig om problemet og dine observationer",
          "Vi undersøger kloakken og lokaliserer årsagen",
          "Vi gennemgår den anbefalede løsning og arbejdets omfang",
          "Vi udfører arbejdet og reetablerer berørte arealer efter aftale"
        ],
        "outro": "Ved gravearbejde indhenter vi oplysninger fra LER, så placeringen af kendte kabler og rør indgår i planlægningen. Berørte arealer reetableres efter aftale, og autorisationskrævende arbejde bliver udført efter gældende regler med den relevante dokumentation."
      },
      {
        "title": "Hvad koster kloakservice?",
        "paragraphs": [
          "Prisen på kloakservice afhænger blandt andet af problemets omfang, adgangsforholdene, behovet for udstyr og om der skal graves. En enkel kloakrensning er en anden opgave end en større kloakrenovering. Derfor vurderer vi opgaven konkret og giver et gennemskueligt tilbud."
        ]
      },
      {
        "title": "Lokalt kloakarbejde med blik for hele opgaven",
        "paragraphs": [
          "Med base i Galten udfører vi kloakservice i bl.a. Galten, Hørning, Låsby, Harlev, Hasselager og Skanderborg - men kører også ud i resten af østjylland. Den lokale placering gør det naturligt for os at hjælpe boligejere, virksomheder, foreninger og ejendomsansvarlige i området med både service og større kloakarbejde.",
          "Som entreprenør og autoriseret kloakmester kan vi samle flere dele af opgaven. Det er en fordel, når kloakken skal undersøges, jorden graves op, installationen ændres og belægning eller græs skal reetableres. På den måde bliver forløbet planlagt med blik for hele ejendommen."
        ]
      },
      {
        "title": "Skal vi finde årsagen sammen?",
        "paragraphs": [
          "Fortæl os, hvad du oplever, så tager vi en grundig samtale om din kloak og de mulige løsninger. Kontakt Entreprenør Jan Hedegaard, hvis du ønsker faglig rådgivning eller et uforpligtende tilbud på kloakservice, kloakspuling, kloakrensning, kloakrenovering eller andet kloakarbejde."
        ]
      }
    ],
    "faq": {
      "display_on_page": true,
      "section_heading": {
        "tag": "h2",
        "text": "Ofte stillede spørgsmål"
      },
      "items": [
        {
          "question_tag": "h3",
          "question": "Hvornår er der behov for kloakservice?",
          "answer_tag": "p",
          "answer": "Langsomme afløb, gurglende lyde, kloaklugt og vand, der ikke løber væk, kan være tegn på blokeringer eller skader i rørene. Entreprenør Jan Hedegaard undersøger årsagen og tilpasser kloakservice til kloaksystemets tilstand og forholdene på ejendommen."
        },
        {
          "question_tag": "h3",
          "question": "Hvad er forskellen på kloakspuling og kloakrensning?",
          "answer_tag": "p",
          "answer": "Kloakspuling bruger vand under tryk til at løsne og skylle snavs og aflejringer ud af rørene. Kloakrensning kan bruges ved en konkret prop eller ved tilbagevendende problemer. Entreprenør Jan Hedegaard vælger metode efter problemets karakter og rørenes tilstand."
        },
        {
          "question_tag": "h3",
          "question": "Hvornår bør kloakken undersøges med kamera?",
          "answer_tag": "p",
          "answer": "En kameraundersøgelse kan være relevant, hvis afløbet ofte stopper, eller hvis lugt og andre gener vender tilbage efter en rensning. Entreprenør Jan Hedegaard bruger kamera og elektronisk sporing til at lokalisere blandt andet forskydninger, brud, rør og brønde."
        },
        {
          "question_tag": "h3",
          "question": "Hvornår er kloakrenovering nødvendig?",
          "answer_tag": "p",
          "answer": "Kloakrenovering kan være nødvendig, når rørene er beskadigede, nedslidte eller ikke længere fungerer korrekt. Entreprenør Jan Hedegaard undersøger installationerne og rådgiver om reparation eller udskiftning ud fra de faktiske forhold."
        },
        {
          "question_tag": "h3",
          "question": "Hvordan foregår autoriseret kloakarbejde?",
          "answer_tag": "p",
          "answer": "Entreprenør Jan Hedegaard begynder med en samtale om problemet og undersøger derefter kloakken for at finde årsagen. Den anbefalede løsning og arbejdets omfang gennemgås, før kloakarbejdet udføres. Autorisationskrævende arbejde udføres efter gældende regler og med relevant dokumentation."
        },
        {
          "question_tag": "h3",
          "question": "Hvad koster kloakservice?",
          "answer_tag": "p",
          "answer": "Prisen på kloakservice afhænger blandt andet af problemets omfang, adgangsforholdene, behovet for udstyr og om der skal graves. Entreprenør Jan Hedegaard vurderer den konkrete opgave og giver et gennemskueligt tilbud, da en kloakrensning og en større kloakrenovering har forskelligt omfang."
        },
        {
          "question_tag": "h3",
          "question": "Kan en kloakmester også håndtere gravearbejde og reetablering?",
          "answer_tag": "p",
          "answer": "Ja. Entreprenør Jan Hedegaard kan samle kloakarbejde, jordarbejde og efterfølgende reetablering af berørte arealer. Ved gravearbejde indhentes oplysninger fra LER, så kendte kabler og rør kan indgå i planlægningen, og have, fliser, græs eller indkørsel reetableres efter aftale."
        }
      ]
    },
    "schema_markup": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvornår er der behov for kloakservice?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Langsomme afløb, gurglende lyde, kloaklugt og vand, der ikke løber væk, kan være tegn på blokeringer eller skader i rørene. Entreprenør Jan Hedegaard undersøger årsagen og tilpasser kloakservice til kloaksystemets tilstand og forholdene på ejendommen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er forskellen på kloakspuling og kloakrensning?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Kloakspuling bruger vand under tryk til at løsne og skylle snavs og aflejringer ud af rørene. Kloakrensning kan bruges ved en konkret prop eller ved tilbagevendende problemer. Entreprenør Jan Hedegaard vælger metode efter problemets karakter og rørenes tilstand."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår bør kloakken undersøges med kamera?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En kameraundersøgelse kan være relevant, hvis afløbet ofte stopper, eller hvis lugt og andre gener vender tilbage efter en rensning. Entreprenør Jan Hedegaard bruger kamera og elektronisk sporing til at lokalisere blandt andet forskydninger, brud, rør og brønde."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er kloakrenovering nødvendig?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Kloakrenovering kan være nødvendig, når rørene er beskadigede, nedslidte eller ikke længere fungerer korrekt. Entreprenør Jan Hedegaard undersøger installationerne og rådgiver om reparation eller udskiftning ud fra de faktiske forhold."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan foregår autoriseret kloakarbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Entreprenør Jan Hedegaard begynder med en samtale om problemet og undersøger derefter kloakken for at finde årsagen. Den anbefalede løsning og arbejdets omfang gennemgås, før kloakarbejdet udføres. Autorisationskrævende arbejde udføres efter gældende regler og med relevant dokumentation."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster kloakservice?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på kloakservice afhænger blandt andet af problemets omfang, adgangsforholdene, behovet for udstyr og om der skal graves. Entreprenør Jan Hedegaard vurderer den konkrete opgave og giver et gennemskueligt tilbud, da en kloakrensning og en større kloakrenovering har forskelligt omfang."
          }
        },
        {
          "@type": "Question",
          "name": "Kan en kloakmester også håndtere gravearbejde og reetablering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja. Entreprenør Jan Hedegaard kan samle kloakarbejde, jordarbejde og efterfølgende reetablering af berørte arealer. Ved gravearbejde indhentes oplysninger fra LER, så kendte kabler og rør kan indgå i planlægningen, og have, fliser, græs eller indkørsel reetableres efter aftale."
          }
        }
      ]
    },
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-070815450-ios.jpg",
        "alt": "Autoriseret kloakservice og kloakarbejde i jorden"
      },
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/87ce90a0-232a-492f-b770-fb9275798d1e.jpg",
        "alt": "Gravemaskine i gang med kloakarbejde"
      }
    ]
  },
  "tv-inspektion": {
    "title": "TV-Inspektion af Kloak & Afløb i Galten | Jan Hedegaard",
    "meta": {
      "description": "Undgå skjulte skader med professionel TV-inspektion af kloakken. Præcis lokalisering af brud og rotteproblemer med kamera. Læs mere her!",
      "ogTitle": "TV-Inspektion af Kloak & Afløb i Galten | Jan Hedegaard",
      "ogDescription": "Undgå skjulte skader med professionel TV-inspektion af kloakken. Præcis lokalisering af brud og rotteproblemer med kamera. Læs mere her!",
      "ogImage": "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-061108879-ios_1.jpg",
      "lang": "da-DK"
    },
    "headline": "Professionel TV-inspektion af kloak",
    "subhead": "En velfungerende kloak er afgørende for både boligens sundhed og daglige funktion. Mange opdager desværre først problemer i kloaksystemet, når skaden allerede er sket – eksempelvis i form af lugtgener, stoppede afløb, fugtskader eller oversvømmede kældre.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Undgå dyre skader med rettidig inspektion",
        "paragraphs": [
          "Med en professionel TV-inspektion af kloakken kan vi undersøge rørsystemet grundigt og opdage problemerne, før de udvikler sig til dyre skader. Som autoriseret kloakmester kobler vi undersøgelsen direkte med praktisk [kloakservice](/kloakservice) og udbedring af eventuelle rørskader.",
          "Vi anvender moderne kamerateknologi og elektronisk sporingsudstyr til at lokalisere rørforløb, brønde og eventuelle skader i kloaksystemet. Det giver os et præcist overblik over kloakkens tilstand og gør det muligt at finde den mest optimale løsning – uanset om der er tale om aflejringer, rørbrud eller forberedelse til [kloakseparering](/kloakseparering)."
        ]
      },
      {
        "title": "Hvad er en TV-inspektion?",
        "paragraphs": [
          "En TV-inspektion er en specialiseret undersøgelsesmetode, hvor et avanceret kamera føres gennem kloak- og spildevandsrørene for at undersøge deres indvendige tilstand.",
          "Metoden gør det muligt at opdage:"
        ],
        "list": [
          "Revner og brud på rør",
          "Rødder i kloakken",
          "Sætninger og forskydninger",
          "Aflejringer og begyndende tilstopninger",
          "Rottehuller og rotteangreb",
          "Defekte eller ødelagte rottespærrer"
        ],
        "outro": "Ved byggeprojekter og renoveringer sikrer TV-inspektionen samtidig, at installationerne er udført korrekt, og at der ikke er opstået skader under arbejdet. Det sparer både tid, besvær og unødige omkostninger."
      },
      {
        "title": "Sådan udfører vi opgaven i praksis",
        "paragraphs": [
          "Når vi rykker ud til en TV-inspektion, starter opgaven med en grundig forberedelse af kloakrørene. For at kameraet kan give et uforstyrret og skarpt overblik, foretager vi ofte en indledende renspuling af ledningen. Det fjerner slam, fedt og belægninger, så rørets faktiske overflader og samlinger fremstår helt tydelige.",
          "Herefter føres vores specialbyggede kloakkamera ind via rense- eller inspektionsbrønden. Kameraet transmitterer livebilleder i høj opløsning direkte op til vores monitor, mens det føres igennem rørsystemet. Undervejs granskes hvert enkelt rørstykke for brud, revner, forskudte samlinger, rødder eller slidtage, og udstyrets metertæller registrerer de præcise afstande.",
          "Finder vi en skade eller et ukendt rørforløb, lokaliserer vi det nøjagtige punkt ved hjælp af elektronisk søgeudstyr og pejlesonde over jorden. Dermed kan vi udpege problemets placering og dybde helt præcist – uden at skulle gætte eller grave unødigt op i indkørsel, have eller belægning.",
          "Når gennemkørslen er afsluttet, gennemgår vi billederne og optagelserne sammen med dig. Du får en klar og faglig vurdering af rørenes stand samt professionel rådgivning om den mest rentable udbedring, hvad enten det kræver højtryksspuling, punktrenovering, strømpeforing eller reparation af et beskadiget rørstykke."
        ]
      },
      {
        "title": "Hvad indebærer en TV-inspektion?",
        "paragraphs": [
          "Vi gennemgår alle centrale dele af dit kloaksystem for at sikre, at alt fungerer optimalt.",
          "En TV-inspektion kan blandt andet omfatte:"
        ],
        "list": [
          "Gennemgang af skelbrønde, samlebrønde og rensebrønde",
          "Lokalisering af skjulte dæksler og rørforløb",
          "Kontrol af rørledningernes fald og flow",
          "Undersøgelse for slidtage og begyndende skader",
          "Lokalisering af brud, revner og utætheder",
          "Dokumentation med videooptagelser og rapport (efter aftale)"
        ],
        "outro": "Uanset om ejendommen har ældre beton, lerrør eller nyere plastrør, tilpasser vi altid inspektionen til den konkrete installation."
      },
      {
        "title": "Hvornår er TV-inspektion en god idé?",
        "paragraphs": [
          "En kamerainspektion af kloakken er særligt relevant i følgende situationer:"
        ],
        "subsections": [
          {
            "title": "Ved gentagne problemer med afløb",
            "paragraphs": [
              "Oplever du ofte stoppede toiletter, langsomt afløb eller dårlig lugt fra kloakken, kan en TV-inspektion hurtigt afsløre årsagen."
            ]
          },
          {
            "title": "Ved køb eller salg af bolig",
            "paragraphs": [
              "Kloakken er sjældent inkluderet i en almindelig tilstandsrapport, da rørene ligger skjult under jorden. Derfor kan skjulte skader blive en meget dyr overraskelse efter et huskøb.",
              "Vi tilbyder uvildig køberrådgivning og kloakinspektion, så du får klar dokumentation for kloakkens tilstand, inden du skriver under."
            ]
          },
          {
            "title": "Ved mistanke om rørskader eller utætheder",
            "paragraphs": [
              "Sætninger i belægninger, fugtige kældervægge eller lugtgener kan være tegn på utætheder eller brud i kloaksystemet. Med TV-inspektion kan vi lokalisere skader og fejl hurtigt og præcist uden opgravning."
            ]
          },
          {
            "title": "Som forebyggende vedligeholdelse",
            "paragraphs": [
              "Ældre kloaksystemer bør løbende kontrolleres for begyndende slid, rødder eller sætninger, før problemerne udvikler sig."
            ]
          }
        ]
      },
      {
        "title": "Effektive løsninger baseret på præcise målinger",
        "paragraphs": [
          "Når TV-inspektionen er gennemført, analyserer vi optagelserne og rådgiver dig om den bedste løsning.",
          "Mindre skader og begyndende problemer kan ofte løses med:"
        ],
        "list": [
          "Højtryksspuling",
          "Rodskæring",
          "Punktrenovering",
          "Strømpeforing"
        ],
        "outro": "Dermed kan man i mange tilfælde undgå større opgravninger og omfattende reparationer. Hvis det bliver nødvendigt med udskiftning eller reparation af rør, står vi som autoriseret kloakmester klar til at udføre arbejdet hurtigt, effektivt og professionelt."
      },
      {
        "title": "Dokumentation og rapport",
        "paragraphs": [
          "Efter udført TV-inspektion kan du efter aftale modtage:"
        ],
        "list": [
          "Videooptagelse af inspektionen",
          "Grundig rapport med vurdering",
          "Dokumentation til forsikring eller kommune",
          "Professionel rådgivning om eventuelle løsninger"
        ],
        "outro": "Det giver dig fuldt overblik over kloakkens tilstand og tryghed for, hvad næste skridt bør være."
      },
      {
        "title": "Kontakt os for TV-inspektion af kloak",
        "paragraphs": [
          "Har du mistanke om problemer i kloakken, eller ønsker du blot sikkerhed for, at alt fungerer korrekt?",
          "Kontakt os i dag for en professionel TV-inspektion og grundig gennemgang af dit kloaksystem. Vi hjælper både private, virksomheder og boligforeninger med sikre og holdbare løsninger."
        ]
      }
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-061108879-ios_1.jpg",
        "alt": "Kamera inspektion af kloakrør"
      }
    ]
  },
  "inspektion": {
    "title": "Kloakinspektion & Fejlfinding | Entreprenør Jan Hedegaard",
    "meta": {
      "ogTitle": "Kloakinspektion & Fejlfinding | Entreprenør Jan Hedegaard",
      "ogDescription": "Få foretaget en professionel inspektion af dit kloaksystem. Vi finder fejlene hurtigt og præcist, så du undgår dyre skader.",
      "ogImage": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/29fc55e4-9492-46c9-b2e0-48fa6f69094e.jpg",
      "lang": "da-DK"
    },
    "headline": "Kloakinspektion og fejlfinding",
    "subhead": "Få foretaget en professionel inspektion af dit kloaksystem. Vi finder fejlene hurtigt og præcist, så du undgår dyre skader.",
    "phone": "+45 22 45 85 67",
    "email": "jan@janhedegaard.dk",
    "sections": [
      {
        "title": "Professionel kloakinspektion",
        "paragraphs": [
          "En velfungerende kloak er afgørende for din boligs sundhed. Desværre opdager de fleste først problemer med kloakken, når skaden er sket – f.eks. i form af lugtgener, stoppede afløb eller kælderoversvømmelser. Med en professionel kloakinspektion kan vi undersøge dit system i dybden og tage problemerne i opløbet.",
          "Vi anvender moderne sporings- og kameraværktøjer til at lokalisere rørforløb, brønde og eventuelle skader. Det giver os et komplet overblik over kloakkens tilstand, så vi kan rådgive dig bedst muligt."
        ]
      },
      {
        "title": "Hvad indebærer en kloakinspektion?",
        "paragraphs": [
          "Vores inspektion dækker alle vitale dele af dit kloaksystem for at sikre, at alt fungerer optimalt:"
        ],
        "list": [
          "Gennemgang af skelbrønde, samlebrønde og rensebrønde",
          "Lokalisering af skjulte dæksler og rørforløb med elektronisk søgeudstyr",
          "Undersøgelse for brud, revner, forskydninger og utætheder",
          "Kontrol af fald på rørledninger for at sikre optimalt flow",
          "Vurdering af slidtage og behov for eventuel renovering"
        ],
        "outro": "Uanset om du bor i et ældre hus med lerrør eller et nyere hus med plastrør, tilpasser vi inspektionen til din ejendom."
      },
      {
        "title": "Undgå dyre overraskelser ved huskøb",
        "paragraphs": [
          "Kloakken er ofte overset i tilstandsrapporten, da den ligger begravet i jorden. Derfor kan det blive en ekstremt dyr overraskelse at overtage et hus med skjulte kloakskader. Vi tilbyder en uvildig køberrådgivning og kloakinspektion, så du kender kloakkens sande tilstand, inden du skriver under på købsaftalen.",
          "Kontakt os i dag for at høre mere om, hvordan vi kan hjælpe dig med en grundig og professionel inspektion af din kloak."
        ]
      }
    ],
    "images": [
      {
        "src": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/29fc55e4-9492-46c9-b2e0-48fa6f69094e.jpg",
        "alt": "Entreprenør Jan Hedegaard firmabil"
      }
    ]
  }
};

export const servicesData = [
  {
    "id": "kloakmester-arbejde",
    "slug": "kloakmester-arbejde",
    "title": "Kloakmesterarbejde",
    "short_description": "Alt kloakarbejde udføres. Vi har mange års erfaring med separering, nedsivning og kloakservice.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/c04241fe-3844-4af5-b58a-5244c3dc4e9b.jpg",
    "icon_name": "Droplets",
    "cta_text": "Læs om autoriseret kloakmesterarbejde"
  },
  {
    "id": "entreprenoerarbejde",
    "slug": "entreprenoerarbejde",
    "title": "Entreprenørarbejde",
    "short_description": "Professionelt jord- og gravearbejde til fundamenter, indkørsler, haver og kloakker med moderne maskiner.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/entr-arbejde1.jpg",
    "icon_name": "HardHat",
    "cta_text": "Se løsninger inden for entreprenørarbejde"
  },
  {
    "id": "kloakservice",
    "slug": "kloakservice",
    "title": "Kloakservice",
    "short_description": "Kloakrensning, kloakspuling, inspektion og reparation udført af autoriseret kloakmester med 20 års erfaring.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-070815450-ios.jpg",
    "icon_name": "Wrench",
    "cta_text": "Få hjælp til professionel kloakservice"
  },
  {
    "id": "kloakseparering",
    "slug": "kloakseparering",
    "title": "Kloakseparering",
    "short_description": "Har du fået påbud om at adskille regn- og spildevand? Autoriseret kloakmester med 20 års erfaring sikrer den rette løsning.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20260329-070521889-ios-1.jpg",
    "icon_name": "Split",
    "cta_text": "Læs om regler for kloakseparering"
  },
  {
    "id": "tv-inspektion",
    "slug": "tv-inspektion",
    "title": "TV-inspektion",
    "short_description": "Professionel kontrol, fejlfinding og vedligeholdelse af dine spildevandsledninger med kamera.",
    "image": "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250517-061108879-ios_1.jpg",
    "icon_name": "Tv",
    "cta_text": "Læs om TV-inspektion og lokalisering"
  },
  {
    "id": "anlaeg-og-belaegning",
    "slug": "anlaeg-og-belaegning",
    "title": "Anlæg og belægning",
    "short_description": "I vores anlægsafdeling beskæftiger vi os med ny anlæg af alle former for belægning, brolægning og støttemure.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/7544e4c2-59ce-4207-b379-e1dab6e0007b.jpg",
    "icon_name": "Grid3X3",
    "cta_text": "Se anlægs- og belægningsarbejde"
  },
  {
    "id": "stoebning-af-beton",
    "slug": "stoebning-af-beton",
    "title": "Støbning af beton",
    "short_description": "Vi udfører fundamenter til tilbygninger, udestuer, orangerier, garager, landbrugshaller osv.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/ind_1.jpg",
    "icon_name": "Construction",
    "cta_text": "Læs om støbning af beton og fundamenter"
  },
  {
    "id": "haveservice",
    "slug": "haveservice",
    "title": "Haveservice",
    "short_description": "Vi tilbyder professionel haveservice samt træfældning og beskæring. Alt fra hækkeklipning og græsslåning to fældning af store træer med topkapper.",
    "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/20250504-075257394-ios-rotated.jpg",
    "icon_name": "Leaf",
    "cta_text": "Læs om haveservice og træfældning"
  }
];

